import React from 'react';


export const BBMP = {
    metaTitle: "Webuildd Construction | Insights | BBMP",
    metaKeyword: "bbmp plan approval, bbmp building plan approval rules, bda plan approval rules, bbmp plan sanction, bbmp building plan approval,",
    metaDescription: "Webuildd construction from Bangalore specializes in residential and commercial construction and offers interior design services with highest quality and transparency.",
    title: "BBMP",
    mainImg: "Images/Insights_detail/BBMP.jpg",
    detail: <> The <b>Bruhat Bengaluru Mahanagara Palike (BBMP)</b>  is the authority in charge of Greater Bengaluru's infrastructure and civic amenities. Acquiring clearance and approval from the BBMP before implementing the building construction is a critical step. The BBMP has the authority to demolish the existing structure or even levy a hefty fine as a penalty for illegal construction within its jurisdiction.<br/><br/>By following the correct procedure, including submission of the appropriate documents and payment of the prescribed fee, the verification will be completed by the concerned BBMP authorities, and you will have all of your documents approved and cleared within 30 days.</>,
    subTitle: "HOW TO SUBMIT A BUILDING PLAN APPROVAL APPLICATION?",
    subImg: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60d5732641e2212c658d387b/img/image-9@2x.jpg",
    description: <><ul><li> The approval application forms can be downloaded and submitted online or offline from the official website.</li><li>The size of the building plan determines the forms to use and the authorized officer to approve the application. The different forms are attached for your perusal to give you better clarity on the terms and details asked in the set documents.</li><li>By duly filling in the suitable application form according to your building size and submitting the following original documents along will enable a hassle-free process –</li></ul></>,
    separator: " | ",
    mSeparator:<><br/></>,
    link1: "Latest BBMP Khata Certificate",
    link2: "Latest Khata Extract ",
    link3: "Latest Tax Paid Receipt",
    link4: "Sale or Title Deed",
    link5: "Conversion Copy (wherever applicable)",
    link6: "Previous Sanctioned Plan",
    link7: "Encumbrance Certificate",
    link8: "Detailed Building Plan",
    link9: "Change of Landuse Copy",
    link10: "Revenue Copy",
    link11: "Architect License Copy",
    subDescription:"Although the first and foremost task of getting the sanctions from the BBMP might seem like a mammoth task, it is a seamless process with the submission of the correct documents. After paying the prescribed fee and submitting the original documents, don't forget to get a copy of the acknowledgment from the office or the web portal. The process of confirmation and verification takes about 30 days for the concerned authorities.",
};

export const BWSSB = {
    metaTitle: "Webuildd Construction | Insights | BWSSB",
    metaKeyword: "borewell cost in Bangalore, borewell application form, borewell permission letter, borewell drilling cost in Bangalore, borewell cost in Bangalore, borewell application form, borewell permission letter, borewell drilling cost in Bangalore",
    metaDescription: "Webuildd construction from Bangalore specializes in residential and commercial construction and offers interior design services with highest quality and transparency.",
    title: "BWSSB",
    mainImg: "Images/Insights_detail/BBMP.jpg",
    detail: <><p>The Bangalore Water Supply and Sewerage Board (BWSSB) is the authority to request a water supply and drainage connection for your newly constructed home in Bengaluru. You will have to fill out an application form from the official BWSSB website: https://owc.bwssb.gov.in/bwssb-owc/member along with a fee of Rs. 100 each for water and sanitary connections, respectively.</p>
    <p>Apart from this, here&#8217;s a list of vital documents and information required that should be handy when applying for the sanitary connection &#8211;</p>
    <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Consumer Details</p>
    <p >&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Property Details</p>
    <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Building Plan &#8211; [floor area of the building with the exact number of toilets, sanitary and plumbing connections, water points, and the overhead and sump tank capacity to be mentioned precisely]</p>
    <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Building photo with the owner</p>
    <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Lease cum sale deed or sale deed</p>
    <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Katha</p>
    <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Occupancy Certificate for a building higher than G+3 floors</p>
    <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Along with the application form, you also need to obtain a permission letter from the authority to cut the road</p>
    <p>Once you choose the right category under which your building belongs (Domestic/ Commercial/ Residential Apartment, etc.), duly filled application forms with the others must be submitted to the assistant executive engineer at the sub-division office.</p>
    <p>It is essential to note that the BWSSB charges differ with registration and approvals. They also vary depending on the type of the building.</p>
    <p>Some of the charges are listed below:</p>
    <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Application fee*</p>
    <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Attachment fee*</p>
    <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Inspection charges*</p>
    <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Three months minimum deposit fee*</p>
    <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Meter Cost (mechanical and AMR) *</p>
    <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Sanitary point charges*</p>
    <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;GBWASP Charges*</p>
    <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Pro-rata charges*</p>
    <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Line cost if any as per actuals*</p>
    <p>*Kindly refer Rates for New Connection at https://owc.bwssb.gov.in/bwssb-owc/member for relevant details specific to your requirement.</p></>,
    subTitle: "",
    subImg: "",
    description: "",
    separator: "",
    mSeparator: "",
    link1: "",
    link2: "",
    link3: "",
    link4: "",
    link5: "",
    link6: "",
    link7: "",
    link8: "",
    link9: "",
    link10: "",
    link11: "",
    subDescription:"",
};

export const BESCOM = {
    metaTitle: "Webuildd Construction | Insights | BESCOM",
    metaKeyword: "bescom new connection charges, bescom new connection, bescom new connection procedure, bescom new connection application form, bescom new connection application status, bescom new connection charges in bangalore, bescom new connection tariff, bescom new connection status",
    metaDescription: "Webuildd construction from Bangalore specializes in residential and commercial construction and offers interior design services with highest quality and transparency.",
    title: "BESCOM",
    mainImg: "Images/Insights_detail/BBMP.jpg",
    detail: <>
<h2 style={{textAlign:"center"}}>BESCOM POWER CONNECTION</h2>
<p>The Bangalore Electricity Supply Company (BESCOM) is the authority responsible for the distribution of electricity in all parts of Bengaluru.</p>
<p>Steps of BESCOM Application Process - </p>
<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Get the application form called the &#8216;A Form&#8217; available at any sub-divisional BESCOM office.</p>
<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;The registration at the office can be done by submitting this duly filled form along with the below-listed documents for a registration fee of Rs. 50 &#8211; </p>
<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8259; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Sale Deed</p>
<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8259; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Katha</p>
<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8259; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Sanctioned plan</p>
<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8259; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Power of Attorney</p>
<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8259; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Latest Rent Paid</p>
<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8259; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Lease Deed</p>
<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8259; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Partnership Deed</p>
<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8259; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Certificate of Incorporation and Memorandum of Association [MOA]</p>
<p>With this, a unique registration number is provided to you, which will help you track your application process and check your submitted documents.</p>
<p><br/></p>
<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;A field officer inspects the house and prepares an estimate after visiting your site.</p>
<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;A sketch of the wiring diagram should be submitted at the office with the Power Supply Agreement and the Test Completion Report signed by the electrical contractor. </p>
<p><br/></p>
<p>You need to make the payment for deposit and inspection charges at this stage. The payments to be made are as follows &#8211; </p>
<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Meter Security Deposit [charges depend on the capacity of the meter to be fixed.]</p>
<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Initial Security Deposit [based on the load].</p>
<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Service line charges.</p>
<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Service connection charges.</p>
<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Post this, a work order is issued by the BESCOM sub-divisional office, and an area engineer in charge of the designated place will fix the meter.</p>
<p>It takes about 30 days to install new connections once you register at the BESCOM office. &nbsp;</p>
<p><br/></p>
<p>NAME CHANGE APPLICATION PROCESS: BESCOM</p>
<p>In case, you want to change the name on the bill receipt, you can submit a formal request at the sub-divisional office with the RR Number of the applicant and personal details such as name, telephone number, and permanent address. Along with this, the below list of documents is a must for submission as well:</p>
<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Copy of Sale Agreement</p>
<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;No Objection Certificate or [NOC] from builder/ owner/ society</p>
<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Sale Deed</p>
<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Tax Payment Receipt</p>
<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Copy of Last Paid Electricity Bill</p>
<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&#8226; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Indemnity Bond</p>
<p><br/></p>
<p>&nbsp;.</p></>,
    subTitle: "",
    subImg: "",
    description: "",
    separator: "",
    mSeparator: "",
    link1: "",
    link2: "",
    link3: "",
    link4: "",
    link5: "",
    link6: "",
    link7: "",
    link8: "",
    link9: "",
    link10: "",
    link11: "",
    subDescription:"",
};

export const Procedure = {
    metaTitle: "Webuildd Construction | Insights | Steps of Construction",
    metaKeyword: "house construction, construction calculator, architecture firms in Bangalore, house builders in Bangalore, Top builders in Bangalore, construction calculator, construction calculator, construction cost per square foot, house builders in Bangalore, Architecture firms in Bangalore, Architecture firms in Bangalore, house construction, house construction, Top builders in Bangalore, Housebuilders in Bangalore,",
    metaDescription: "Webuildd construction from Bangalore specializes in residential and commercial construction and offers interior design services with highest quality and transparency.",
    title: "Procedure",
    mainImg: "Images/Insights_detail/BBMP.jpg",
    detail: 
            <>
                <h2 style={{textAlign:"center"}}>The following are the building construction steps in detail</h2>
                <p><img width="100%" height="auto" alt="" src="Images/Insights_detail/Procedure/procedure.jpg"/></p>
                <h3>I) Pre-construction Steps:</h3>
                <p >If you are an aspiring homeowner and wish to construct your dream home, the first step is to find the right plot in the location and size preferred by you while ensuring that it is free of litigations or dispute. You can approach a well-experienced lawyer and the BDA (or a similar body operational in the region you choose) to check for the site's authenticity. Clearing the land with the BDA and getting floor plans sanctioned by the BBMP are crucial aspects of &nbsp;<strong>house construction</strong>. The chosen plot should be well connected with amenities that you and your family require not just in the present, but in the future too. Observing the recent development of the location can also certify a steady rate of appreciation for your investment.</p>
                <p>While you finalise your plot, it is also important to check for the nature of the soil and do a soil test; the land can be a paddy field, agricultural field, or a plot with hard soil. This is crucial as the construction cost can turn exorbitant for the laying of the foundation depending on the nature of soil it is built upon.</p>
                <p >Once you find the right plot, take the help of a&nbsp;<b>construction calculator</b>&nbsp;to give you an overall estimate of the expenditure to build the home of your liking. Subsequently, you can approach one of the good&nbsp;<b>architecture firms in Bangalore</b>&nbsp;to help you visualise and plan your dream abode.&nbsp;&nbsp;</p>
                <p >If you seek to buy a flat or a villa, it is important to choose a project that is well connected offering a range of amenities with superior quality construction and appreciation value. You can learn more about the different&nbsp;<b>house builders in Bangalore</b>&nbsp;through customer reviews and make an informed decision about what you wish to purchase.&nbsp;<b>Top builders in Bangalore</b>&nbsp;generally ensure that they choose a location that has a wholesome approach and shows good potential as an investment.</p>
                <h3 >Seek technical help&nbsp;</h3>
                <p >Use the estimate provided by the&nbsp;<b>construction calculator</b>&nbsp;to set a benchmark for the&nbsp;<b>construction cost per square foot</b>. Compare the rate of&nbsp;<b>construction cost per square foot</b>&nbsp;that varied&nbsp;<b>house builders in Bangalore</b>&nbsp;are offering.&nbsp;<b>Architecture firms in Bangalore</b>&nbsp;can help you plan your home and offer you design solutions based on your preference.</p>
                <p ><br/></p>
                <h3 >Choosing the right team of consultants</h3>
                <p >There are many good&nbsp;<b>architecture firms in Bangalore</b>&nbsp;that can be approached to build your dream home. It is important to work with someone who understands your aspirations, limitations, and schedule in order to complete your dream abode peacefully and in time. The efficiency of the architect in providing you the most optimised solution and their ability to work with other consultants must not be overlooked. Your&nbsp;<b>house construction</b>&nbsp;is the result of the teamwork of different consultants like architects, civil engineers, electrical engineers, etc. Thus, all of them have to be experienced and reliable to make the&nbsp;<b>house construction</b>&nbsp;a smooth sailing process. While you work with your architect to finalize the design, the specifications like roles and responsibilities, payments, the material used, labour, schedule, etc. have to be documented properly. A contract has to be laid out for the benefit of both parties involved to ensure that the project is completed as specified.</p>
                <p >The role of your team doesn't end with the completion of the&nbsp;<b>house construction</b>, but they will have to offer continued support after you occupy the home and may need some minor works to be done.</p>
                <p ><br/></p>
                <h3 >Planning your finances&nbsp;</h3>
                <p >Once you have an estimate and a design at hand, you can start looking at the finer details like the material and finishes to be used. It is important to look into these factors at this stage as this further defines the cost of your home. If you are having any financial restrictions, this would be the right time to apply for a home loan. You will have to submit the license for construction, plans approved by the BBMP, and legitimate documents in order to secure a loan. Planning your finances is important in order to ensure that you have ample money to see the construction through. Lack of financial planning and organisation can cause an infinite delay in the completion of your home.</p>
                <p ><br/></p>
                <h3 >Permissions and paperwork&nbsp;</h3>
                <p >No construction can begin until you have permission from the BBMP.&nbsp;<b>Architecture firms in Bangalore</b>&nbsp;can provide you with plans that are done in adherence to the bylaws of the region you are constructing in. You will need various documents along with drawings that will help you get permission to build. Some of the documents that you may need are listed below. But it is important to remember that these documents can vary depending on the municipal body that you are dealing with:</p>
                <p ><br/></p>
                <p ><mark>- Land survey: Land survey should be performed under the guidance of a designated land surveyor.</mark></p>
                <p ><mark>- Land survey report: A report will be prepared after the survey which has to be submitted for approval.</mark></p>
                <p ><mark>- Records on the property: The past records and legal documents of the property are to be submitted.</mark></p>
                <p >- Architectural drawings: Detailed drawings in adherence to the bylaws have to be provided.</p>
                <p >- Architect's Certificate of Company Record and Civil Engineer's Certificate on Record: The license and other details of your architect and engineer have to be submitted.</p>
                <p >Along with the sanction from BBMP, you will also need many other approvals and permissions like:</p>
                <p >&#8226; Approval to dig a borewell</p>
                <p >&#8226; Approval to cut trees if required</p>
                <p >&#8226; BBMP/BDA Plan approval</p>
                <p >&#8226; BESCOM/KEB- Temp Connection</p>
                <p >While the ones above are needed before the construction begins, there are some more permissions that you will require before occupying your home. Some of the post-construction legalities are mentioned below:</p>
                <p >&#8226; BESCOM/KEB connection for your home is essential to ensure that your home has electricity running before you occupy it.</p>
                <p >&#8226; BWSSB water connection on a permanent basis is crucial. Some localities like new layouts and developments might not have this facility, in which case it is important to contact the local municipal bodies to find out more about the alternatives.</p>
                <p ><br/></p>
                <h3 >II) Building Construction Stage Process</h3>
                <p ><br/></p>
                <h3 >1) Site Planning or Levelling:&nbsp;</h3>
                <p >The first step is to clean the site thoroughly and to do research about the content on the site. One might find roots of trees, debris, etc which will have to be removed and the site will have to be levelled. Usually, after the site is levelled, a temporary shed is built with a temporary power supply.</p>
                <p ><br/></p>
                <h3 >2. Layout Marking:&nbsp;&nbsp;</h3>
                <p >The accepted design boundaries are marked in the initial stage of the&nbsp;<b>house construction</b>&nbsp;on the levelled site. After this, the precise dimensions and layout for the foundation is chalked out.</p>
                <p ><br/></p>
                <h3 >3. Excavation:</h3>
                <p >Depending on the structural design provided by the structural engineer, the excavation is done to facilitate the laying of the foundation.&nbsp;<b>Top builders in Bangalore</b>&nbsp;might excavate much deeper as they would have to build a high rise structure along with multi-level basements. The dimensions of the excavation depend on many factors like the height of the structure, nature of the soil, etc.</p>
                <p ><br/></p>
                <h3 >4.&nbsp;The laying of the foundation&nbsp;comprises of many activities. They are as listed below:</h3>
                <p ><br/></p>
                <h4 >&#8226; Compacting the ground:</h4>
                <p >The excavated pits are trimmed and evened out where the base is compacted using hand compactors.&nbsp;&nbsp;</p>
                <h4 >&#8226;PCC:</h4>
                <p >In order to create a stable foundation the reinforcement is tied and the footing is positioned, PCC has to be laid. A simple cement concrete mixture in the proportions of 1:4:8 or 1:3:6 is laid at varying depths on the compacted earth.</p>
                <h4 >&#8226; Footing Reinforcement:</h4>
                <p >Reinforced steel bars are tied together and integrated into the PCC to form a foundation. The concrete is then poured and the rods of the columns are removed.</p>
                <h4 >&#8226;Shuttering:</h4>
                <p >This has to be done in accordance with the drawings as provided by the structural engineer. Shuttering is crucial to achieving the dimensions and shape as specified in the drawings. It is used to keep the concrete in shape till it sets completely and prevents any contact with the soil.</p>
                <p ><br/></p>
                <h4 >&#8226;Footing Concrete:</h4>
                <p >Before any more concrete work is undertaken, it is important to check the foundation. If the excavated depths have to be in line with the drawings. If there is any variation, more concrete is poured in as per the site map. Foundation depth ranges from 9 "to 18", but a standard of 12 "depth is used in most cases. The width of the base is held equal to its profundity.&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</p>
                <p ><br/></p>
                <h3 >5. Column Casting:&nbsp;</h3>
                <p >The shuttering base is fastened to cast the columns. Concrete is poured into the framework at intervals as mentioned in the structural drawings. Usually, the shuttering is removed after 24hrs of casting and curing is finished.</p>
                <p ><br/></p>
                <h3 >6. Wall Construction:&nbsp;</h3>
                <p >There are different types of masonry and material that can be used in&nbsp;<b>house construction</b>. One can use stone masonry, wooden walls, burnt bricks, hollow blocks, and many others.&nbsp;<b>Housebuilders in Bangalore</b>&nbsp;also use prefabricated concrete walls, different types of concrete blocks depending on the scale of construction, and their budget. The foundation of the wall is first built using concrete or stone masonry. Required opening for doors, windows, and ventilators are created and the masonry is done to create spatial segregation as specified by the architectural drawings</p>
                <p ><br/></p>
                <h3 >7. Lintel:</h3>
                <p >The framework and masonry are the most time-consuming activities undertaken. During the masonry, openings are created and the tops of the openings are strengthened with reinforced concrete panels with cement. The wooden frames are then attached to this so that the weight of the structure does not impact the wooden members directly.&nbsp;</p>
                <p ><br/></p>
                <h3 >8. Roofing:</h3>
                <p >The final concrete roofing is poured after the masonry work is completed. The thickness of the slab and the amount of reinforcement to be used and other specifications will be as per the drawings and details provided by the structural engineer.</p>
                <p ><br/></p>
                <h3 >9. Plastering:</h3>
                <p >&nbsp;No work is done for about 14 days after the slab is laid. Plastering begins once the slab is completely set. Usually, a mortar is created using the standard proportions of 1:3 or 1:4 for plasterwork. The thickness of the plastering will not be more than 0.75inches. It takes about 7 days to cure on the surface. Plastering is not just done for concrete members but for brick masonry as well. It adds to the strength of the walls and any gaps or crevices are filled using plaster.</p>
                <p ><br/></p>
                <h3 >10. Attachment of doors and windows:&nbsp;</h3>
                <p ><b>Housebuilders in Bangalore</b>&nbsp;often prefer to use timber doors and windows. Apart from this, steel or aluminium fixtures can also be used. If one is opting for wooden doors and windows, then the frames are set within the masonry of the walls. After the plastering is completed, the frames are placed and the panels are fastened in place with hinges. If one is opting for aluminium or steel doors or windows, these can be installed after the painting is done.&nbsp;&nbsp;</p>
                <p ><br/></p>
                <h3 >11. Electrical and plumbing work:&nbsp;</h3>
                <p >Grouting and sunken slabs etc. are creating while the concrete is laid and masonry is undertaken. But the wiring, installation of switchboards, etc. is undertaken after the plastering is done. All the plumbing and electrical work are done before the painting and tiling is done so as to ensure that little damage occurs to the final finished space.</p>
                <p ><br/></p>
                <h3 >12. Tiling and flooring:&nbsp;</h3>
                <p >While there is no restriction on where tiles can be used, we most frequently see them on the walls of bathrooms and kitchens. Wall tiles are installed first, followed by the laying of floor tiles. There are many options that one can choose from when it comes to tiling and flooring. They can choose from marble, granite, bricks, epoxy, etc. while wooden flooring is also becoming a popular choice, especially for bedrooms.</p>
                <p ><br/></p>
                <h3 >13. Painting:</h3>
                <p >The last stage of your&nbsp;<b>house construction</b>&nbsp;is the painting. There are many options available in the market depending on your preference and budget. There is 1 layer of primer and 2 layers of water-based paint or 2 coat of putty and 2 coat of paint for seamless coating. There are also different paints and finishes that you can choose for internal and external surfaces. Apart from this, woodwork and wallpapers are now a trend and are much sought after as wall finishes.</p>
            </>,
    subTitle: "",
    subImg: "",
    description: "",
    separator: "",
    mSeparator: "",
    link1: "",
    link2: "",
    link3: "",
    link4: "",
    link5: "",
    link6: "",
    link7: "",
    link8: "",
    link9: "",
    link10: "",
    link11: "",
    subDescription:"",
};

export const Vaastu = {
    metaTitle: "Webuildd Construction | Insights | Vastu",
    metaKeyword: "Vastu for House Construction, Vastu for home construction, Vastu for house construction, Vastu tips for home foundation, Vastu for starting house construction, Vastu for construction of new house, Vastu for house construction, Vastu tips for house construction, Vastu for building house, Vastu tips for home construction, Vastu shastra for home, construction, importance of Vastu in house construction, Vastu in house construction, basic Vastu for house construction",
    metaDescription: "Webuildd construction from Bangalore specializes in residential and commercial construction and offers interior design services with highest quality and transparency.",
    title: "Vaastu",
    mainImg: "Images/Insights_detail/BBMP.jpg",
    detail: 
            <>
                <h2 style={{textAlign:"center"}}>Vastu for Your Dream Home</h2>
                <p >Once you have purchased the plot of your liking, the process of designing and constructing your dream home begins. Vastu plays a significant role in the planning of your house. Being mindful about some basic principles of Vastu can help you achieve a space that is peaceful and promotes a healthy and tranquil life.&nbsp;</p>
                <p >Most&nbsp;<b>house builders in Bangalore</b>&nbsp;follow the basic principles of Vastu to design their projects. Here are some Vastu principles that you should remember while designing your home:&nbsp;</p>
                <p style={{marginLeft:"50px"}}>&#8226; &nbsp;&nbsp;The <b>entrance door</b>&nbsp;should ideally be in the North, Northeast, and East in East-facing and North-facing plot. It should be in the southeast and south in the South-facing plot, West and Northwest in the West-facing plot. &nbsp;It is also important to remember that a maximum of two entrance doors is encouraged in a house; anything more would be considered inauspicious.</p>
                <p ><img width="275" height="200" alt="" src="Images/Insights_detail/Vastu/vastu1.jpg" />&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<img width="275" height="200" alt="" src="Images/Insights_detail/Vastu/vastu2.jpg" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<img width="275" height="200" alt="" src="Images/Insights_detail/Vastu/vastu3.jpg" /></p>
                <p ><br /></p>
                <p ><br /></p>
                <p ></p>
                <p >&#8226;&nbsp;&nbsp;It is most ideal to have open space in the northeast of the house. Your home design should ensure that there is more open space in the North and East as compared to the South and West.</p>
                <p ><img width="272" height="203" alt="" src="Images/Insights_detail/Vastu/vastu4.jpg" /></p>
                <p ><br /></p>
                <p >&#8226;&nbsp;&nbsp;The master bedroom&nbsp;should be placed in the southwest part of the house. </p>
                <p ><br /></p>
                <p ><img width="280" height="211" alt="" src="Images/Insights_detail/Vastu/vastu5.jpg" />&nbsp; &nbsp; &nbsp;</p>
                <p >Other bedrooms:</p>
                <p ><img width="283" height="212" alt="" src="Images/Insights_detail/Vastu/vastu6.jpg" /><img width="283" height="212" alt="" src="Images/Insights_detail/Vastu/vastu7.jpg" /></p>
                <p >&nbsp; &nbsp;</p>
                <p ><br /></p>
                <p >&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</p>
                <p >&#8226;&nbsp;&nbsp;The <b>pooja room</b>&nbsp;should be placed in the northeast part of the house. </p>
                <p ><img width="250" height="186" alt="" src="Images/Insights_detail/Vastu/vastu8.jpg" /></p>
                <p ><br /></p>
                <p >&#8226;&nbsp;&nbsp;The <b>kitchen</b>&nbsp;should be situated in the southeast part of the house. The next best location for the kitchen would be the northwest. </p>
                <p ><img width="250" height="186" alt="" src="Images/Insights_detail/Vastu/vastu9.jpg" /></p>
                <p ><br /></p>
                <p >&#8226;&nbsp;&nbsp;West or northwest is the best placement for the <b>toilet</b>. The <b>bathroom</b>&nbsp;is ideally placed in the northeast, north, east or northwest of the house.</p>
                <p ><img width="255" height="191" alt="" src="Images/Insights_detail/Vastu/vastu10.jpg" /></p>
                <p ><br /></p>
                <p >&#8226;&nbsp;&nbsp;If you are planning a <b>basement</b>&nbsp;in your dream house, then it should be planned in the northern or eastern part of the house.</p>
                <p ><img width="258" height="194" alt="" src="Images/Insights_detail/Vastu/vastu11.jpg" /></p>
                <p ><br /></p>
                <p >&#8226;&nbsp;&nbsp;When you are <b>choosing the paint</b>, you should choose light colours. According to Vastu, red and black are colours that are best avoided in a house. </p>
                <p ><img width="300" height="258" alt="" src="Images/Insights_detail/Vastu/vastu12.jpg" /></p>
                <p ><br /></p>
                <p >The principles of Vastu are not just limited to spatial planning of your residence, you can use <b>Vastu for house construction</b>&nbsp;as well. Here are some Vastu principles to implement during the construction process: </p>
                <div style={{marginLeft:"50px"}}>
                    <p >&#8226;&nbsp;&nbsp;Before the construction begins, the plot must be cleaned out and plants, stones, bushes or any other thrash should be removed. </p>
                    <p >&#8226;&nbsp;&nbsp;There should be no break in the construction process; it should happen continuously and smoothly.</p>
                    <p >&#8226;&nbsp;&nbsp;The construction work should ideally be done during the day and not during the night. </p>
                    <p >&#8226;&nbsp;&nbsp;According to <b>Vastu for house construction</b>, the compound wall should be built before the construction of the house. </p>
                    <p >&#8226;&nbsp;&nbsp;Preferably, only new material should be used for construction and one should refrain from reusing old material like old doors, steel bars etc. </p>
                    <p >&#8226;&nbsp;&nbsp;Same material should be used for both the shutter as well as the frame of an opening. Two different materials should not be used. </p>
                    <p >&#8226;&nbsp;&nbsp;The source of water is best placed in the northeast, north or east directions. It is advisable to avoid the southwest, southeast and northwest directions for the placement of a water source. It is also believed to be inauspicious to have a water sump in the middle of the house.</p>
                    <p >&#8226;&nbsp;&nbsp;According to the <b>Vastu for house construction</b>, the excavation of land should be started from the northeast corner and should then proceed towards the East, North, South and towards the West in the end.</p>
                    <p >&#8226;&nbsp;&nbsp;The foundation should be laid in the southwest corner first followed by the northwest and southeast and then it can be laid from northwest to northeast. </p>
                    <p >&#8226;&nbsp;&nbsp;Vastu encourages one to build a storage shed or room on site instead of dumping construction material in the open. </p>
                </div>
                <p ><b>Top builders in Bangalore</b> follow the basic Vastu principles while planning their homes in order to offer Vastu compliant homes to their customers. Likewise, if you are approaching <b>architecture firms in Bangalore</b> for your house construction, they too can implement the basic principles if requested. &nbsp; &nbsp;</p>
                <p ><br /></p>
                <p ><img width="288" height="216" alt="" src="Images/Insights_detail/Vastu/vastu13.jpg" /><img width="287" height="215" alt="" src="Images/Insights_detail/Vastu/vastu14.jpg" /></p>
            </>,
    subTitle: "",
    subImg: "",
    description: "",
    separator: "",
    mSeparator: "",
    link1: "",
    link2: "",
    link3: "",
    link4: "",
    link5: "",
    link6: "",
    link7: "",
    link8: "",
    link9: "",
    link10: "",
    link11: "",
    subDescription:"",
};

export const ByeLaws = {
    metaTitle: "Webuildd Construction | Insights | Bye laws, FAR & Built-up Area & Carpet Area",
    metaKeyword: "house construction in Bangalore, floor area ratio in Bangalore, built-up area, super built-up area, BBMP byelaws, top builders in Bangalore, architectural firms in Bangalore, super built-up area, built-up area, top builders in Bangalore, floor area ratio, built up area, carpet area, carpet area means, super built-up area, floor area, floor space index, built up area meaning, super built-up area meaning, carpet area and built-up area, carpet area to built up area",
    metaDescription: "Webuildd construction from Bangalore specializes in residential and commercial construction and offers interior design services with highest quality and transparency.",
    title: "Bye Laws",
    mainImg: "Images/Insights_detail/BBMP.jpg",
    detail: 
            <>
                <h2 style={{textAlign:"center"}}>Bye laws, FAR &amp; Built up Area &amp; Carpet Area</h2>
                <p >If you are keen to begin your&nbsp;house construction in Bangalore, there are some terminologies like the floor area ratio in Bangalore, built-up area, super built-up area, and the BBMP bye laws that may seem confusing or hard to comprehend. Both BBMP and the BDA are significant bodies when it comes to construction and land in Bangalore, and one must corroborate that they are adhering to the norms set by the concerned authorities. Else, one pays a hefty price leading to unpleasant consequences to the extent of demolition or refusal of an occupational certificate.&nbsp;Thus, whether you choose to buy from&nbsp;top builders in Bangalore&nbsp;or approach&nbsp;architectural firms in Bangalore&nbsp;to design your home, it is pivotal to know the bye-laws and norms to build safely without breaching any rules. </p>
                <p >Before we discuss some important bye-laws that you must keep in mind, let us first look at some terminologies that will help you understand the process of construction better:&nbsp;</p>
                <h3 >1. Plot Area:</h3>
                <p >A plot area is the marked out area that you have legally purchased from a reliable seller. It is marked using a boundary or a fence, and the term plot is often used in gated communities, townships etc. </p>
                <p ><img width="40%" height="auto" alt=""  src="Images/Insights_detail/ByeLaws/byelaws1.png"/></p>
                <h3 >2. Built-Up Area/Plinth Area:</h3>
                <p >As the term explains itself, it is the built part of your plot. It is excluding the open spaces and setbacks that you have left. This is an important term in the process of your house construction. &nbsp;The plinth or built up area is calculated in the following way: </p>
                <p >Built up Area = Carpet area+ Thickness of All walls + balcony </p>
                <p ><img width="40%" height="auto" alt=""  src="Images/Insights_detail/ByeLaws/byelaws2.png"/></p>
                <h3 >3. Setback area:</h3>
                <p >The open space or setbacks that you have left around the building during your house construction&nbsp;is called the setback area. The setbacks to be left are determined by the BBMP byelawsand depend on various factors like size of plot, typology of the built space, height of the building, road width etc. </p>
                <p >The setback area is used for circulation around the building, parking, ventilation etc. The method to calculate the setback area is as follows: </p>
                <p >Setback area = Plot area &#8211; Built-up Area</p>
                <p ><img width="40%" height="auto" alt=""  src="Images/Insights_detail/ByeLaws/byelaws3.png"/></p>
                <h3 >4. Carpet area:</h3>
                <p >Carpet Area is the area within walls or in other words, it is the built up area excluding the area of the walls. &nbsp;It is the area that is actually available for utilisation in a building. Ideally it should be around 85-90% of the built-up area. The process to calculate the carpet area is as follows: </p>
                <p >Carpet Area = Built-up Area- Area of walls </p>
                <h3 >5. Super Built-up Area:</h3>
                <p >In a building, there are many other features other than just a home that is used by an individual. Depending on which type of building you have chosen, there are features like swimming pool, common lobby, common staircase, lifts, parking, etc. which is shared by all the occupants of the building. The super built-up area&nbsp;is the built-up area&nbsp;plus a proportion of the area taken up by all the other amenities. This term is often heard in case of buying a home from top builders in Bangaloreas it is a common feature in apartments and villas. Usually the top builders in Bangalore&nbsp;may add upto 20% of total cost of apartment to the super built-up area&nbsp;of each unit. </p>
                <p >You can also take the help of a construction calculator&nbsp;to derive the different areas as discussed above. In order to get a better understanding of the terms discussed, you can go through the following plan: </p>
                <p ><img width="40%" height="auto" alt=""  src="Images/Insights_detail/ByeLaws/byelaws4.png"/></p>
                <h3 >Factors Determining Setbacks:</h3>
                <p >The objective of setbacks is to ensure ample sunlight, ventilation,&nbsp;greenery&nbsp;and vehicular access to the buildings in that particular location. These days, the rising building density in cities is creating havoc and disturbance for the vehicular movement of emergency servicesduring a mishap as well.Therefore, the better the location and the larger the plot size, the greater the setback requirement.</p>
                <p >The byelaws set by the BBMP primarily depend on the following factors:</p>
                <p >&#9679;&nbsp;&nbsp;&nbsp;Size of the plot</p>
                <p >&#9679;&nbsp;&nbsp;&nbsp;Whether it is one-side or multi-side open plot</p>
                <p >&#9679;&nbsp;&nbsp;&nbsp;Locality or neighbourhood&nbsp;where the plot is located</p>
                <p >&#9679;&nbsp;&nbsp;&nbsp;Width of the road on which the plot is located</p>
                <p >&#9679;&nbsp;&nbsp;&nbsp;Maximum permitted coverage area in the locality</p>
                <p s>According to the BBMP bye-laws in Bangalore, </p>
                <p s>&#8226; The front and the rear setback is determined with reference to depth of the site. The left and right setbacks are determined in reference to width of the site and if the building is up to 11.5 m height, the setbacks are calculated as percentage of depth and width of the site.</p>
                <p >For example, for a 30*40 plot of 1200 sq. ft in Bangalore, as per the BBMP/BDA bye-laws, a minimum of 8% setback has to be given on all three sides and 12% on the front facing the road depending on the depth and width of the site.</p>
                <h3>BDA Bye Laws (Revised Master Plan 2015) </h3>
                <div style={{overflow:"auto"}}>
                <table border="1" >
                <tr valign="top">
                    <th valign="top" >
                    </th>
                    <th colspan="2" valign="middle" ><p >Width of site </p>
                    </th>
                    <th colspan="2" valign="middle" ><p >Depth of site</p>
                    </th>
                </tr>
                <tr valign="top">
                    <td valign="top" ><p >Width/Depth of site ( m ) </p>
                    </td>
                    <td valign="top" ><p >Right side </p>
                    </td>
                    <td valign="top" ><p >Left side </p>
                    </td>
                    <td valign="top" ><p >Front side </p>
                    </td>
                    <td valign="top" ><p >Rear side</p>
                    </td>
                </tr>
                <tr valign="top">
                    <td valign="top" ><p >Up to 6.0 </p>
                    </td>
                    <td valign="top" ><p >1.0 m </p>
                    </td>
                    <td valign="top" ><p >0 </p>
                    </td>
                    <td valign="top" ><p >1.0 m </p>
                    </td>
                    <td valign="top" ><p >0</p>
                    </td>
                </tr>
                <tr valign="top">
                    <td valign="middle" ><p >Above 6.0 up to 9.0 </p>
                    </td>
                    <td colspan="4" valign="middle" ><p >1.0 m on all sides</p>
                    </td>
                </tr>
                <tr valign="top">
                    <td valign="middle" ><p >Above 9.0 m </p>
                    </td>
                    <td valign="middle" ><p >8 % </p>
                    </td>
                    <td valign="middle" ><p >8% </p>
                    </td>
                    <td valign="middle" ><p >12% </p>
                    </td>
                    <td valign="middle" ><p >8%</p>
                    </td>
                </tr>
            </table>
                </div>
                <p s>Note: For plot over size of 4000 sq.m, a minimum setback of 5.0 m on all sides shall be<br/>insisted.</p>
                <h3>BBMP Bye Laws</h3>
                <div style={{overflow:"auto"}}>
                <table  border="1" >
                <tr valign="top">

                    {/* <th rowspan="2" valign="top" ><p >Depth in Mtr</p>
                    </th>
                    <th colspan="2" valign="top" ><p >Residential</p>
                    </th>
                    <th colspan="2" valign="top" ><p >Commercial</p>
                    </th>
                    <th rowspan="2" valign="top" ><p >Depth in Mtr</p>
                    </th>
                    <th colspan="2" valign="top" ><p >Residential</p>
                    </th>
                    <th colspan="2" valign="top" ><p >Commercial</p>
                    </th> */}
                    <td rowspan="2" valign="top" ><p >Depth in Mtr</p>
                    </td>
                    <td colspan="2" valign="top" ><p >Residential</p>
                    </td>
                    <td colspan="2" valign="top" ><p >Commercial</p>
                    </td>
                    <td rowspan="2" valign="top" ><p >Depth in Mtr</p>
                    </td>
                    <td colspan="2" valign="top" ><p >Residential</p>
                    </td>
                    <td colspan="2" valign="top" ><p >Commercial</p>
                    </td>
                </tr>
                <tr valign="top">
                    <td valign="middle" ><p >Front</p>
                    </td>
                    <td valign="middle" ><p >Rear</p>
                    </td>
                    <td valign="middle" ><p >Front</p>
                    </td>
                    <td valign="middle" ><p >Rear</p>
                    </td>
                    <td valign="middle" ><p >Left</p>
                    </td>
                    <td valign="middle" ><p >Right</p>
                    </td>
                    <td valign="middle" ><p >Left</p>
                    </td>
                    <td valign="middle" ><p >Right</p>
                    </td>
                </tr>
                <tr valign="top">
                    <td valign="top" ><p >Up to 6</p>
                    </td>
                    <td valign="top" ><p >1.00</p>
                    </td>
                    <td valign="top" ><p >-</p>
                    </td>
                    <td valign="top" ><p >1.00</p>
                    </td>
                    <td valign="top" ><p >-</p>
                    </td>
                    <td valign="top"><p >Up to 6</p>
                    </td>
                    <td valign="top" ><p >-</p>
                    </td>
                    <td valign="top" ><p >1.00</p>
                    </td>
                    <td valign="top" ><p >-</p>
                    </td>
                    <td valign="top" ><p >-</p>
                    </td>
                </tr>
                <tr valign="top">
                    <td valign="top" ><p >Over 6<br />up to 9</p>
                    </td>
                    <td valign="top" ><p >1.00</p>
                    </td>
                    <td valign="top" ><p >1.00</p>
                    </td>
                    <td valign="top" ><p >1.50</p>
                    </td>
                    <td valign="top" ><p >-</p>
                    </td>
                    <td valign="top" ><p >Over 6<br />up to 9</p>
                    </td>
                    <td valign="top" ><p >1.00</p>
                    </td>
                    <td valign="top" ><p >1.00</p>
                    </td>
                    <td valign="top" ><p >-</p>
                    </td>
                    <td valign="top" ><p >1.50</p>
                    </td>
                </tr>
                <tr valign="top">
                    <td valign="top" ><p >Over 9<br />up to 12</p>
                    </td>
                    <td valign="top" ><p >1.50</p>
                    </td>
                    <td valign="top" ><p >1.50</p>
                    </td>
                    <td valign="top" ><p >1.50</p>
                    </td>
                    <td valign="top" ><p >1.50</p>
                    </td>
                    <td valign="top" ><p >Over 9<br />up to 12</p>
                    </td>
                    <td valign="top" ><p >1.50</p>
                    </td>
                    <td valign="top" ><p >1.50</p>
                    </td>
                    <td valign="top" ><p >1.50</p>
                    </td>
                    <td valign="top" ><p >1.50</p>
                    </td>
                </tr>
                <tr valign="top">
                    <td valign="top" ><p >Over 12<br />up to 18</p>
                    </td>
                    <td valign="top" ><p >3.00</p>
                    </td>
                    <td valign="top" ><p >1.50</p>
                    </td>
                    <td valign="top" ><p >3.00</p>
                    </td>
                    <td valign="top" ><p >1.50</p>
                    </td>
                    <td valign="top" ><p >Over 12<br />up to 18</p>
                    </td>
                    <td valign="top" ><p >1.50</p>
                    </td>
                    <td valign="top" ><p >3.00</p>
                    </td>
                    <td valign="top" ><p >1.50</p>
                    </td>
                    <td valign="top" ><p >3.00</p>
                    </td>
                </tr>
                <tr valign="top">
                    <td valign="top" ><p >Over 18<br />up to 24</p>
                    </td>
                    <td valign="top" ><p >4.00</p>
                    </td>
                    <td valign="top" ><p >3.00</p>
                    </td>
                    <td valign="top" ><p >3.50</p>
                    </td>
                    <td valign="top" ><p >3.00</p>
                    </td>
                    <td valign="top" ><p >Over 18<br />up to 24</p>
                    </td>
                    <td valign="top" ><p >2.50</p>
                    </td>
                    <td valign="top" ><p >3.50</p>
                    </td>
                    <td valign="top" ><p >2.50</p>
                    </td>
                    <td valign="top" ><p >4.00</p>
                    </td>
                </tr>
                <tr valign="top">
                    <td valign="top" ><p >Over 24</p>
                    </td>
                    <td valign="top" ><p >5.00</p>
                    </td>
                    <td valign="top" ><p >3.50</p>
                    </td>
                    <td valign="top" ><p >4.50</p>
                    </td>
                    <td valign="top" ><p >3.00</p>
                    </td>
                    <td valign="top" ><p >Over 24</p>
                    </td>
                    <td valign="top" ><p >3.00</p>
                    </td>
                    <td valign="top" ><p >4.00</p>
                    </td>
                    <td valign="top" ><p >3.00</p>
                    </td>
                    <td valign="top" ><p >4.50</p>
                    </td>
                </tr>
            </table>
                </div>
                <p s>[A pictorial representation can be given]</p>
                <p >&#8226; If it is a corner sites both the sides facing the road should be treated as front side and the regulations pertaining to both should be applied. &nbsp;</p>
                <p >&#8226; If the building is facing more than two roads then it should be treated as a corner site and the rules for two of the wider roads should be applied. </p>
                <p >&#8226; If the site is facing roads on both the front and the rear, both the sides should be treated as the front. The other two sides not facing roads should be treated as the right and the setbacks should be left accordingly.</p>
                <p >&#8226; If the site is of an irregular shape the set-backs are to be calculated as per the depth orwidth at the points where the depths or width is varying. Average set-backs cannot be considered in such instances. </p>
                <p >&#8226; If there is any open space like a park, public space or a conservancy lane, the setback is to be provided by the plot owner. The existing open space cannot be considered as a setback. </p>
                <p ><br/></p>
                <h3 >What is FLOOR AREA RATIO or [FAR]?</h3>
                <p >The Floor area ratio is the ratio of a building's total floor area to the size of the plot on which it is built. The floor area ratio varies owing to a lot of factors:the size of the plot, typology of the built space, road width and the zoning under which it falls. Bangalore is divided into three zones based on the intensity of the development and can be classified as intensely developed, moderately developed and sparsely. Top builders in Bangalore can be relied upon to follow all the aforementioned byelaws when they undertake a project along with using the apt FAR as applicable to that region. </p>
                <p >In the Bangalore Revised Master Plan 2015, the FSI varies from 1.75 for smaller plots to 3.35 for larger plots. The exact value depends on factors like specific location, building typology, size of the plot and the road width. </p>
                <p >For instance, if you have a plot of size 30*40ft, where 30ft is the width and the depth is 40ft, the FAR will be 1.75 which adds upto 2100sq. ft. This is built-up area that is permissible for you to construct on your site where the road width is 30 ft. after leaving the setbacks as per guidelines. </p>
                <p ><img width="40%" height="auto" alt=""  src="Images/Insights_detail/ByeLaws/byelaws5.png"/></p>
                <p>(A similar pic can represent a house with 30*40 plot)</p>
                <p ><img width="40%" height="auto" alt=""  src="Images/Insights_detail/ByeLaws/byelaws6.png"/></p>
                <p >[A representation of the same in a picture would be effective]</p>
                <p ><br/></p>
                <p >As we are well aware, the construction cost per square foot&nbsp;in Bangalore is quite high, hence it becomes very important to make the most of the build-up area available. The tables below will help you understand more about the exact FAR which is derived based on various factors. </p>
                <p ><br/></p>
                <div style={{overflow:"auto"}}>
                <table >
                <tr >
                <th  ><p >.No. </p>
                </th>
                <th  ><p >Plot size (sq.m) </p>
                </th>
                <th  ><p >Ground Coverage.<br/>(Max ) </p>
                </th>
                <th  ><p >FAR </p>
                </th>
                <th  ><p >Road width (m)</p>
                </th>
                </tr>
                <tr >
                <td  ><p >1. </p>
                </td>
                <td  ><p >Up to 360 </p>
                </td>
                <td  ><p >Up to 75 % </p>
                </td>
                <td  ><p >1.75 </p>
                </td>
                <td><p >Up to 12.0</p>
                </td>
                </tr>
                <tr >
                <td  s><p >2. </p>
                </td>
                <td  ><p >Above 360 </p>
                <p >up to 1000 </p>
                </td>
                <td  ><p >Up to 65 % </p>
                </td>
                <td  ><p >2.25 </p>
                </td>
                <td  ><p >Above 12.0 up to 18.0</p>
                </td>
                </tr>
                <tr >
                <td  s><p >3 </p>
                </td>
                <td  ><p >Above 1000<br/>up to 2000 </p>
                </td>
                <td  ><p >Up to 60 % </p>
                </td>
                <td  ><p >2.50 </p>
                </td>
                <td ><p >Above 18.0 up to 24.0</p>
                </td>
                </tr>
                <tr >
                <td  s><p >4. </p>
                </td>
                <td  ><p >Above 2000<br/>up to 4000 </p>
                </td>
                <td  ><p >Up to 55 % </p>
                </td>
                <td  ><p >3.00 </p>
                </td>
                <td  ><p >Above 24.0 up to 30.0</p>
                </td>
                </tr>
                <tr >
                <td  s><p >5. </p>
                </td>
                <td  ><p >Above 4000<br/>up to 20000 </p>
                </td>
                <td  ><p >Up to 50 % </p>
                </td>
                <td  ><p >3.25 </p>
                </td>
                <td ><p >Above 30.m</p>
                </td>
                </tr>
                </table>
                </div>
                <p ><br/></p>
                <h3><mark>General Building Bye-Laws:</mark></h3>
                <p ><mark><b>Here are some general building bye laws that you will have to keep in mind before the construction of your dream home: </b></mark></p>
                <p >&#8226; <mark>If the authorities consider a site to be unsanitary due it's incapability to be well drained, construction on it cannot be undertaken. It is dangerous to build on plots that cannot be drained completely. </mark></p>
                <p >&#8226; <mark>Construction cannot be undertaken on a landfill or on any land that is used to fill up filth and garbage. A certificate from the Health Officer and Corporation Engineer claiming that it is safe from the health and sanitation perspective is needed. </mark></p>
                <p >&#8226; <mark>If the chosen site is within a distance of nine meters from the water spread area of a tank at fulltank level is considered, the owner must show the measures taken to prevent damp. If this is to the satisfaction of the authorities, and permission is granted, only then can construction be undertaken. </mark></p>
                <p >&#8226; <mark>If there are electrical lines running, one must remember that no building can be constructed below an electrical line, as well as within the horizontal distance from the electrical line.</mark> </p>
                <p><mark><img width="40%" height="auto" alt=""  src="Images/Insights_detail/ByeLaws/byelaws7.jpg"/></mark></p>
                <p >&#8226; <mark>It is important to remember that a building cannot encroach a means of access or reduce its width nor can it obstruct the access to other buildings which are exclusively accessed by that road or lane. </mark></p>
                <p >&#8226; <mark>The means of access to the plot should be clearly marked out in the plans submitted for sanction and proper lighting, manhole covers etc should be provided for the same.</mark></p>
                
            </>,
    subTitle: "",
    subImg: "",
    description: "",
    separator: "",
    mSeparator: "",
    link1: "",
    link2: "",
    link3: "",
    link4: "",
    link5: "",
    link6: "",
    link7: "",
    link8: "",
    link9: "",
    link10: "",
    link11: "",
    subDescription:"",
};

export const TipsIdeas = {
    metaTitle: "Webuildd Construction | Insights | Construction Tips & Construction Ideas",
    metaKeyword: "construction cost in Bangalore, house construction cost in Bangalore, construction cost per square feet in Bangalore",
    metaDescription: "Webuildd construction from Bangalore specializes in residential and commercial construction and offers interior design services with highest quality and transparency.",
    mainImg: "Images/Insights_detail/BBMP.jpg",
    detail: 
            <>
                <h2 style={{textAlign:"center"}}>Construction Tips &amp; Construction Ideas</h2>
                <p >Your dream home is an amalgamation of your dreams, hopes, and aspirations. It is a reflection of your aesthetic sense and your mind-set. For most of us, it takes the savings of a lifetime to build a home as the&nbsp;<b>construction cost per square feet in Bangalore</b>&nbsp;is certainly high.&nbsp;</p>
                <p >When a massive investment goes into construction, it is advisable to cut costs wherever possible. Whether you are using up your savings or taking a loan, it is important to construct your home in such a way that you get the most of what you spend and do not exceed your budget in any way.</p>
                <p >Keeping in mind the&nbsp;<b>house construction cost in Bangalore</b>, here are some tips that can help you make the most of your investment:&nbsp;</p>
                <div style={{marginLeft:"20px"}}>
                <p >&#9679;&nbsp;&nbsp;Using Cement Blocks instead of Bricks&nbsp;can cut costs. They are also more durable and can carry heavy loads as compared to bricks.&nbsp;</p>
                <p >&#9679;&nbsp;&nbsp;Using M-sand instead of River Sand&nbsp;will reduce the&nbsp;<b>construction cost in Bangalore</b>.&nbsp;The process of procuring river sand is tedious and also the illegal mining of the same has become an obstacle in a city like Bangalore.&nbsp;</p>
                <p >&#9679;&nbsp;&nbsp;Red Sal Honne Frames are a cheaper option as compared to Teak. While teak does have a great finish and is much preferred amongst most people due to its superior quality finish and durability, the price makes it a high-end preference. When Red sal is finished well and the workmanship is good, that too can give you a great outcome.&nbsp;</p>
                <p >&#9679;&nbsp;&nbsp;UPVC Windows are more cost-effective&nbsp;as compared to windows made of honne, red sal, or teak. They are easier to install or change whenever the need arises and come in a lot of varieties too. You can choose from multiple options to ensure that your windows are not only strong but soundproof and weatherproof too.&nbsp;</p>
                <p >&#9679;&nbsp;&nbsp;A-frame structure comprising of columns and beam is cheaper than a load-bearing structure. Traditional structure made of walls is not preferred for multiple floors and load-bearing structures are faster to build, cost-effective and stronger too. They are the perfect choice if you are building multiple floors or wish to add more floors in the future.&nbsp;</p>
                <p >&#9679;&nbsp;&nbsp;<b>House construction cost in Bangalore</b>&nbsp;would be cheaper if you used ready mix concrete instead of site-mix concrete&nbsp;as the process is faster and more convenient. It also requires less labour thus making the process cheaper and more efficient.&nbsp;</p>
                <p >&#9679;&nbsp;&nbsp;Ready-made solid doors are a cheaper option&nbsp;as compared to honne shutters for doors as they are mass-manufactured, simpler to assemble and install. You also have varied options and finishes to choose from.&nbsp;</p>
                <p >&#9679;&nbsp;&nbsp;Vitrified Tiles are a cheaper option and a good replacement for Italian marble, Granite, or Marble. You can choose from a myriad of colours, grains, and finishes. Comparing different brands and their offerings can help you select the best flooring for your home that not only looks great but is economic too.&nbsp;</p>
                <p >&#9679;&nbsp;&nbsp;Choosing a good architect can help you optimise your space&nbsp;while reducing the number of walls and unnecessary fixtures. Using their expertise in the industry and knowledge from having studied designs from across the globe, they can help you optimize your space to the maximum.&nbsp;</p>
                <p >&#9679;&nbsp;&nbsp;You have to be confident about the architectural and structural design. Also, ensure that there are no mistakes done on-site&nbsp;as both these instances lead to changes which will, in turn, increase the cost of construction. The estimate that you receive from the&nbsp;<b>construction cost calculator</b>&nbsp;has to be followed and any deviation from this can increase the cost manifold.&nbsp;</p>
                <p >&#9679;&nbsp;&nbsp;Make sure that your estimate and structural drawings come with accurate material information to be used, the time frame required, etc. so that your material is utilised to the maximum capacity&nbsp;and nothing is wasted.&nbsp;</p>
                <p >&#9679;&nbsp;&nbsp;Try to work with a builder&nbsp;who can get the material at the best price and arrange the cheapest logistics for the same.&nbsp;</p>
                <p >&#9679;&nbsp;&nbsp;Piece work contract is efficient&nbsp;and can be a viable option to structure the task and its deadline seamlessly.</p>
                <p >&#9679;&nbsp;&nbsp;If you have any excavation to be done, opt for JCB excavation&nbsp;as manual excavation can be expensive and time-consuming.&nbsp;</p>
                <p >&#9679;&nbsp;&nbsp;Make the most of the flooring material&nbsp;by experimenting with different ideas and combinations. Not only does it help you create something out of what you have, but you can also end up with something truly uncommon and extraordinary.&nbsp;</p>
                <p >&#9679;&nbsp;&nbsp;Instead of opting for elaborate wall finishes, choose the most economical one that is easy to maintain and long-lasting.&nbsp;</p>
                <p >&#9679;&nbsp;&nbsp;If you are moving out to a rented property while your house is being constructed, make sure that there are no substantial delays as it will lead to longer periods of paying rent, thus increasing the overall cost of construction as well.&nbsp;</p>
                </div>
                <p ><br /></p>
                <p >While we do understand that the&nbsp;<b>construction cost per square feet in Bangalore</b>&nbsp;can be high, it is essential to understand what can be built on your plot based on the plot size. After having spent close to 15 years in the construction industry, we have had the opportunity to work on diverse sites and plot sizes. Owing to this experience in the industry, we have teamed with many consultants to offer our clients the most optimised solutions based on their requirements and plot sizes.&nbsp;</p>
                <p >Using this expertise, we have listed some possibilities that can be attempted in plots that are available across Bangalore:&nbsp;</p>
                <p ><br /></p>
                <h3 >Plot size: 20ft*30ft </h3>
                <p >If you are looking to build for the purpose of letting out for rent or to use for your family, here are the two options that would work best for you. The rental units can be rented to individuals living alone or to small families. </p>
                <h3 >Option 1- 1 BHK unit with parking. </h3>
                <div >
                    <table width="400" border="1">
                    <tr valign="top">
                        <th valign="top" ><p >ROOM</p>
                        </th>
                        <th valign="top" s><p >STANDARD SIZE [Sqft. covered]</p>
                        </th>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Hall</p>
                        </td>
                        <td valign="top" s><p >10 x 12 [120]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Kitchen</p>
                        </td>
                        <td valign="top" s><p >7 x 9 [65]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Dining &#8211; 4 seater</p>
                        </td>
                        <td valign="top" s><p >[40]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Bedroom</p>
                        </td>
                        <td valign="top" s><p >10 x 12 (queen size bed) [120]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Toilet</p>
                        </td>
                        <td valign="top" s><p >[40]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Parking</p>
                        </td>
                        <td valign="top" s><p >12 x 8 [120]</p>
                        </td>
                    </tr>
                </table>
                </div>
                <p > &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<b>Total built-up area: 480 Sqft.&nbsp;approx</b></p>
                <p ><br /></p>
                <h3 >Option 2- 1 BK unit [Studio]</h3>
                <div ><table width="400" border="1" >
                    <tr valign="top">
                        <th valign="top" ><p >ROOM</p>
                        </th>
                        <th valign="top" s><p >STANDARD SIZE [Sqft. covered]</p>
                        </th>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Hall/ Kitchen</p>
                        </td>
                        <td valign="top" s><p >10 x 12 [120]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Kitchen</p>
                        </td>
                        <td valign="top" s><p >6 x 9 [54]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Toilet</p>
                        </td>
                        <td valign="top" s><p >8 x 4 [32]</p>
                        </td>
                    </tr>
                </table>
                </div>
                <p > &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<b>Total built-up area: 200 Sqft.&nbsp;approx</b></p>
                <p ><br /></p>
                <h3 >Option 3- Duplex</h3>
                <div ><table width="400" border="1" >
                    <tr valign="top">
                        <th valign="top" ><p >ROOM</p>
                        </th>
                        <th valign="top" s><p >STANDARD SIZE [Sqft. covered]</p>
                        </th>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Living + Kitchen + Utility &amp; Puja</p>
                        </td>
                        <td valign="top" s><p >18 x 10 [180]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Staircase</p>
                        </td>
                        <td valign="top" s><p >5 x 10 [50]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Dining &#8211; 4 seater</p>
                        </td>
                        <td valign="top" s><p >[40]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Master Bedroom</p>
                        </td>
                        <td valign="top" s><p >16 x 14 (king size bed) [224]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Bedroom</p>
                        </td>
                        <td valign="top" s><p >10 x 12 (queen size bed) [120]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Toilet [2 nos]</p>
                        </td>
                        <td valign="top" s><p >[40] </p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Parking</p>
                        </td>
                        <td valign="top" s><p >12 x 8 [120]</p>
                        </td>
                    </tr>
                </table>
                </div>
                <p > &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<b>Total built-up area: 1000 Sqft.&nbsp;approx</b></p>
                <p ><br /></p>
                <h3 >Plot size: 30ft*40ft </h3>
                <p >This is suitable for someone who would like an independent home for their family and to let out for rent. The rental units are suited for single occupancy or for small to medium sized families. The following options are possible: </p>
                <h3 >Option 1- GF for Rental with two units of 1-BHK</h3>
                <div ><table width="400" border="1" >
                    <tr valign="top">
                        <th valign="top" ><p >ROOM</p>
                        </th>
                        <th valign="top" s><p >STANDARD SIZE [Sqft. covered]</p>
                        </th>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Hall</p>
                        </td>
                        <td valign="top" s><p >10 x 12 [120]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Kitchen</p>
                        </td>
                        <td valign="top" s><p >7 x 9 [65]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Dining&#8211; 4 seater</p>
                        </td>
                        <td valign="top" s><p >[40]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Bedroom</p>
                        </td>
                        <td valign="top" s><p >10 x 12 (queen size bed) [120]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Toilet</p>
                        </td>
                        <td valign="top" s><p >[40]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Parking</p>
                        </td>
                        <td valign="top" s><p >12 x 8 [120]</p>
                        </td>
                    </tr>
                </table>
                </div>
                <p > &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<b>Total built-up area: 480 Sqft.&nbsp;approx</b></p>
                <h3 >Option 2- GF for own use: 2-BHK</h3>
                <div ><table width="400" border="1" >
                    <tr valign="top">
                        <th valign="top" ><p >ROOM</p>
                        </th>
                        <th valign="top" s><p >STANDARD SIZE [Sqft. covered]</p>
                        </th>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Hall</p>
                        </td>
                        <td valign="top" s><p >10 x 12 [120]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Kitchen + Utility</p>
                        </td>
                        <td valign="top" s><p >8 x 8 + 4 x 8 [100]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Puja</p>
                        </td>
                        <td valign="top" s><p >[40]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Dining &#8211; 4 seater</p>
                        </td>
                        <td valign="top" s><p >[60]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Bedroom [2 nos]</p>
                        </td>
                        <td valign="top" s><p >10 x 12 (queen size bed) [120]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Toilet [2 nos]</p>
                        </td>
                        <td valign="top" s><p >[40]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Parking</p>
                        </td>
                        <td valign="top" s><p >12 x 8 [120]</p>
                        </td>
                    </tr>
                </table>
                </div>
                <p > &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<b>Total built-up area: 750 Sqft.&nbsp;approx.</b></p>
                <h3 >Option 3 &#8211; Duplex 3-BHK</h3>
                <div ><table width="400" border="1" >
                    <tr valign="top">
                        <th valign="top" ><p >ROOM</p>
                        </th>
                        <th valign="top" s><p >STANDARD SIZE [Sqft. covered]</p>
                        </th>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Hall</p>
                        </td>
                        <td valign="top" s><p >10 x 12 [120]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Kitchen + Utility</p>
                        </td>
                        <td valign="top" s><p >8 x 8 + 4 x 8 [100]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Puja</p>
                        </td>
                        <td valign="top" s><p >[40]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Dining &#8211; 4 seater</p>
                        </td>
                        <td valign="top" s><p >[60]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Bedroom [3nos]</p>
                        </td>
                        <td valign="top" s><p >10 x 12 (queen size bed) [120]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Toilet [2 nos]</p>
                        </td>
                        <td valign="top" s><p >[40]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Parking</p>
                        </td>
                        <td valign="top" s><p >12 x 8 [120]</p>
                        </td>
                    </tr>
                </table>
                </div>
                <p > &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<b>Total built-up area: 950 Sqft.approx.</b></p>
                <p ><br /></p>
                <h3 >Plot size: 30ft*50ft </h3>
                <p >This is a good plot size for <b>house construction in Bangalore.</b> You can make multiple rental units or an independent home for yourself. The rental units can be given to individuals who live alone or to a small/medium sized families depending on the number of rooms. </p>
                <h3 >Option 1 &#8211; GF for Rental with three units of 1-BHK</h3>
                <div ><table width="400" border="1" >
                    <tr valign="top">
                        <th valign="top" ><p >ROOM</p>
                        </th>
                        <th valign="top" s><p >STANDARD SIZE [Sqft. covered]</p>
                        </th>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Hall</p>
                        </td>
                        <td valign="top" s><p >10 x 12 [120]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Kitchen</p>
                        </td>
                        <td valign="top" s><p >7 x 9 [65]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Dining &#8211; 4 seater</p>
                        </td>
                        <td valign="top" s><p >[40]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Bedroom</p>
                        </td>
                        <td valign="top" s><p >10 x 12 (queen size bed) [120]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Toilet</p>
                        </td>
                        <td valign="top" s><p >[40]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Parking</p>
                        </td>
                        <td valign="top" s><p >12 x 8 [120]</p>
                        </td>
                    </tr>
                </table>
                </div>
                <p > &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<b>Total built-up area: 480 Sqft.&nbsp;approx</b></p>
                <h3 >Option 2 &#8211; GF for own use: 3-BHK</h3>
                <div ><table width="400" border="1" >
                    <tr valign="top">
                        <th valign="top" ><p >ROOM</p>
                        </th>
                        <th valign="top" s><p >STANDARD SIZE [Sqft. covered]</p>
                        </th>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Hall</p>
                        </td>
                        <td valign="top" s><p >10 x 12 [120]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Kitchen + Utility</p>
                        </td>
                        <td valign="top" s><p >8 x 8 + 4 x 8 [100]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Puja</p>
                        </td>
                        <td valign="top" s><p >[40]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Dining &#8211; 4 seater</p>
                        </td>
                        <td valign="top" s><p >[60]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Bedroom [3 nos]</p>
                        </td>
                        <td valign="top" s><p >10 x 12 (queen size bed) [120]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Toilet [2 nos]</p>
                        </td>
                        <td valign="top" s><p >[40]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Parking</p>
                        </td>
                        <td valign="top" s><p >12 x 8 [120]</p>
                        </td>
                    </tr>
                </table>
                </div>
                <p > &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<b>Total built-up area: 950 Sqft.&nbsp;approx.</b></p>
                <h3>Plot size: 40ft*50ft </h3>
                <p >The square plot is quite an advantage to work with various permutations and combinations to offer a spacious home with optional rental units on the ground floor. This is even a good size plot to self-indulge and build a swanky, elegant and comfortable abode for yourself. Some of the options that you can try on this plot size are: </p>
                <h3 >Option 1 &#8211; Rentals 1-BHK, 4 units</h3>
                <div ><table width="400" border="1" >
                    <tr valign="top">
                        <th valign="top" ><p >ROOM</p>
                        </th>
                        <th valign="top" s><p >STANDARD SIZE [Sqft. covered]</p>
                        </th>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Hall</p>
                        </td>
                        <td valign="top" s><p >10 x 12 [120]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Kitchen </p>
                        </td>
                        <td valign="top" s><p >7 x 9 [63]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Puja</p>
                        </td>
                        <td valign="top" s><p >[40]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Dining &#8211; 4 seater</p>
                        </td>
                        <td valign="top" s><p >[40]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Bedroom </p>
                        </td>
                        <td valign="top" s><p >10 x 12 (queen size bed) [120]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Toilet </p>
                        </td>
                        <td valign="top" s><p >[40]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Parking</p>
                        </td>
                        <td valign="top" s><p >12 x 8 [120]</p>
                        </td>
                    </tr>
                </table>
                </div>
                <p > &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<b>Total built-up area: 360 Sqft.&nbsp;approx.</b></p>
                <h3 >Option2 &#8211; GF for own use: 4-BHK</h3>
                <div ><table width="400" border="1" >
                    <tr valign="top">
                        <th valign="top" ><p >ROOM</p>
                        </th>
                        <th valign="top" s><p >STANDARD SIZE [Sqft. covered]</p>
                        </th>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Hall</p>
                        </td>
                        <td valign="top" s><p >10 x 12 [120]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Kitchen + Utility</p>
                        </td>
                        <td valign="top" s><p >8 x 8 + 4 x 8 [100]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Puja</p>
                        </td>
                        <td valign="top" s><p >[40]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Dining &#8211; 4 seater</p>
                        </td>
                        <td valign="top" s><p >[60]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Bedroom [3 nos]</p>
                        </td>
                        <td valign="top" s><p >10 x 12 (queen size bed) [120]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Toilet [2 nos]</p>
                        </td>
                        <td valign="top" s><p >[40]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Parking</p>
                        </td>
                        <td valign="top" s><p >12 x 8 [120]</p>
                        </td>
                    </tr>
                </table>
                </div>
                <p > &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<b>Total built-up area: 950 Sqft.&nbsp;approx.</b></p>
                <p ><br /></p>
                <p ><br /></p>
                <h3>Plot size: 40ft*60ft </h3>
                <p >This a handsome plot size and can be used for varied purposes. You can make multiple 1-BHK or 2-BHK units as rentals or a luxurious home for your family. You can opt to build an independent home or a penthouse for yourself with lower floors as rental units. Some of the options that you can try on this plot size are: </p>
                <h3>Option1 &#8211; Rentals 1-BHK, 5 units</h3>
                <div ><table width="400" border="1" >
                    <tr valign="top">
                        <th valign="top" ><p >ROOM</p>
                        </th>
                        <th valign="top" s><p >STANDARD SIZE [Sqft. covered]</p>
                        </th>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Hall</p>
                        </td>
                        <td valign="top" s><p >10 x 12 [120]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Kitchen </p>
                        </td>
                        <td valign="top" s><p >7 x 9 [63]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Puja</p>
                        </td>
                        <td valign="top" s><p >[40]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Dining &#8211; 4 seater</p>
                        </td>
                        <td valign="top" s><p >[40]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Bedroom </p>
                        </td>
                        <td valign="top" s><p >10 x 12 (queen size bed) [120]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Toilet </p>
                        </td>
                        <td valign="top" s><p >[40]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Parking</p>
                        </td>
                        <td valign="top" s><p >12 x 8 [120]</p>
                        </td>
                    </tr>
                </table>
                </div>
                <p > &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<b>Total built-up area: 360 Sqft.&nbsp;approx.</b></p>
                <p ><br /></p>
                <h3 >Option 2- GF for own use: 2-BHK, 3 units</h3>
                <div ><table width="400" border="1" >
                    <tr valign="top">
                        <th valign="top" ><p >ROOM</p>
                        </th>
                        <th valign="top" s><p >STANDARD SIZE [Sqft. covered]</p>
                        </th>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Hall</p>
                        </td>
                        <td valign="top" s><p >10 x 12 [120]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Kitchen + Utility</p>
                        </td>
                        <td valign="top" s><p >8 x 8 + 4 x 8 [100]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Puja</p>
                        </td>
                        <td valign="top" s><p >[40]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Dining &#8211; 4 seater</p>
                        </td>
                        <td valign="top" s><p >[60]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Bedroom [2nos]</p>
                        </td>
                        <td valign="top" s><p >10 x 12 (queen size bed) [120]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Toilet [2 nos]</p>
                        </td>
                        <td valign="top" s><p >[40]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Parking</p>
                        </td>
                        <td valign="top" s><p >12 x 8 [120]</p>
                        </td>
                    </tr>
                </table>
                </div>
                <p > &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<b>Total built-up area: 720 Sqft.&nbsp;approx.</b></p>
                <p ><br /></p>
                <h3>Option 3 &#8211; GF for own use: 3-BHK, 2 units</h3>
                <div ><table width="400" border="1" >
                    <tr valign="top">
                        <th valign="top" ><p >ROOM</p>
                        </th>
                        <th valign="top" s><p >STANDARD SIZE [Sqft. covered]</p>
                        </th>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Hall</p>
                        </td>
                        <td valign="top" s><p >10 x 12 [120]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Kitchen + Utility</p>
                        </td>
                        <td valign="top" s><p >8 x 8 + 4 x 8 [100]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Puja</p>
                        </td>
                        <td valign="top" s><p >[40]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Dining &#8211; 4 seater</p>
                        </td>
                        <td valign="top" s><p >[60]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Bedroom [3 nos]</p>
                        </td>
                        <td valign="top" s><p >10 x 12 (queen size bed) [120]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Toilet [2 nos]</p>
                        </td>
                        <td valign="top" s><p >[40]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Parking</p>
                        </td>
                        <td valign="top" s><p >12 x 8 [120]</p>
                        </td>
                    </tr>
                </table>
                </div>
                <p > &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<b>Total built-up area: 950 Sqft.&nbsp;approx</b></p>
                <p ><br /></p>
                <h3 >Option 4 &#8211; GF for own use: 4-BHK</h3>
                <div ><table width="400" border="1" >
                    <tr valign="top">
                        <th valign="top" ><p >ROOM</p>
                        </th>
                        <th valign="top" s><p >STANDARD SIZE [Sqft. covered]</p>
                        </th>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Hall</p>
                        </td>
                        <td valign="top" s><p >10 x 12 [120]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Kitchen + Utility</p>
                        </td>
                        <td valign="top" s><p >8 x 8 + 4 x 8 [100]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Puja</p>
                        </td>
                        <td valign="top" s><p >[40]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Dining &#8211; 4 seater</p>
                        </td>
                        <td valign="top" s><p >[60]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Bedroom [3 nos]</p>
                        </td>
                        <td valign="top" s><p >10 x 12 (queen size bed) [120]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Toilet [2 nos]</p>
                        </td>
                        <td valign="top" s><p >[40]</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >Parking</p>
                        </td>
                        <td valign="top" s><p >12 x 8 [120]</p>
                        </td>
                    </tr>
                </table>
                </div>
                <p > &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<b>Total built-up area: 950 sf tapprox.</b></p>
                <p >In order to help you understand better, here is a summary: </p>
                <p ><br /></p>
                <div style={{overflow:"auto"}}>
                    <table width="619" border="1" >
                    <tr valign="top">
                        <th valign="top" ><p >Dimensions</p>
                        </th>
                        <th valign="top" ><p >Ground floor</p>
                        </th>
                        <th valign="top" ><p >Ground floor+ 1st&nbsp;floor</p>
                        </th>
                        <th valign="top"><p >3BHK </p>
                        </th>
                        <th valign="top" ><p >4BHK</p>
                        </th>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >20*30 </p>
                        </td>
                        <td valign="top" ><p >1BHK+CP</p>
                        </td>
                        <td valign="top" ><p >2BHK+CP</p>
                        </td>
                        <td valign="top"><p >NA</p>
                        </td>
                        <td valign="top" ><p >NA</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >30*40</p>
                        </td>
                        <td valign="top" ><p >2BHK+CP or 1BHK-2 nos+ CP</p>
                        </td>
                        <td valign="top" ><p >3BHK DUPLEX</p>
                        </td>
                        <td valign="top"><p >1 no with small size bedrooms</p>
                        </td>
                        <td valign="top" ><p >NA</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >30*50</p>
                        </td>
                        <td valign="top" ><p >2BHK + BP or 1BHK 2nos + CP</p>
                        </td>
                        <td valign="top" ><p >3BHK Duplex</p>
                        </td>
                        <td valign="top" ><p >1 no with medium size bedrooms</p>
                        </td>
                        <td valign="top" s><p >NA</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >40*50</p>
                        </td>
                        <td valign="top" ><p >1BHK-3nos+Cp,</p>
                            <p >2BHK+CP</p>
                        </td>
                        <td valign="top" ><p >3BHK Duplex</p>
                        </td>
                        <td valign="top" ><p >1nos </p>
                        </td>
                        <td valign="top" s><p >1nos</p>
                        </td>
                    </tr>
                    <tr valign="top">
                        <td valign="top" ><p >40*60</p>
                        </td>
                        <td valign="top" ><p >1BHK-3nos+CP,</p>
                            <p >2BHK-2nos+CP</p>
                            <p >3BHK-1no+CP,</p>
                            <p >4BHK-1no+CP</p>
                        </td>
                        <td valign="top" ><p >3BHK Duplex+ CP, </p>
                            <p >4BHK Duplex+ CP, 5BHK Duplex+ CP</p>
                        </td>
                        <td valign="top"><p >1no </p>
                        </td>
                        <td valign="top" ><p >1 no- with medium size bedrooms</p>
                        </td>
                    </tr>
                </table>
                </div>
                <p ><br /></p>
                <p >Based on the standard plots, the above list is curated to give you a basic idea to optimize your space in accordance to requirements that are common in today&#8217;s occurrence. However, approaching <b>good architectural firms in Bangalore</b> or reputed <b>house builders in Bangalore</b> gives you the freedom to customize your dream home, tailored to meet your needs and specifications. </p>
                <p ><br /></p>
            </>,
    subTitle: "",
    subImg: "",
    description: "",
    separator: "",
    mSeparator: "",
    link1: "",
    link2: "",
    link3: "",
    link4: "",
    link5: "",
    link6: "",
    link7: "",
    link8: "",
    link9: "",
    link10: "",
    link11: "",
    subDescription:"",
};

export const Budget = {
    metaTitle: "Webuildd Construction | Insights | Budget",
    metaKeyword: "construction cost, construction budget , budget for your house construction, construction cost in Bangalore, the overall budget estimate, house construction budget, construction cost per square feet in Bangalore, construction cost in Bangalore, house construction cost in Bangalore, building a house on a budget, Bangalore house construction cost calculator, 30x40 construction cost in Bangalore, duplex house construction cost in Bangalore, cost of building a house in Bangalore, building construction cost in Bangalore, house construction cost in Bangalore 2020, low cost house construction in Bangalore, construction labour rates in Bangalore, construction cost per square feet in Bangalore 2020, construction cost per square feet in Bangalore, house construction budget",
    metaDescription: "Webuildd construction from Bangalore specializes in residential and commercial construction and offers interior design services with highest quality and transparency.",
    title: "Budget",
    mainImg: "Images/Insights_detail/BBMP.jpg",
    detail: 
    <>
        <h1 style={{textAlign:"center"}}>Budget</h1>
        <p>Often, when one is determining the&nbsp;<b>house construction cost in Bangalore</b>, a round figure or an overall estimate of the&nbsp;construction budget &nbsp;is demanded without looking at it in parts and phases. It must be acknowledged that an efficient way to plan the&nbsp;budget for your house construction &nbsp;is to categorize and look at it in stages. This is an effective way to prepare yourself to spend for an upcoming activity as per schedule. The overall&nbsp; construction cost in Bangalore &nbsp;is dependent on varied factors such as the size of your plot, quality of material used, and the scale of construction.&nbsp;</p>
        <p>Despite these factors, it is essential to understand that&nbsp; the overall budget estimate &nbsp;can be broken down into two main categories:</p>
        <p>(1) &nbsp;Compliance Cost: &nbsp;which is the money invested in taking care of all the regulations that need to be followed as per the authorities. Here are some of the sanctions and permissions that you need to pay for:</p>
        <ul style={{marginLeft:"20px"}}>
            <li> Sanction Drawings - a certain fee has to be paid to the BBMP authorities to submit sanction drawings</li>
            <li>Electricity - In order to get an electricity connection from BESCOM or Bangalore Electricity Supply Company, a certain amount has to be paid. There are also charges for permanent meter board, panel board grounding, UG cabling cost, etc. Don&#8217;t forget, you will also have to pay for transformer apart from the aforementioned charges.</li>
            <li>Water - As per the charges levied by the BWSSB or the Bangalore Water Supply and Sewerage Board, one must be prepared to pay a certain amount to get the water supply in place. It includes charges for road cutting and other official and unofficial charges</li>
        </ul>
        <p>There are many other charges levied by the government that one needs to pay in order to get the construction started and to smoothly move into their new home. Often, this may not be considered as a part of the budget as this does not come under the <b>construction cost per square feet in Bangalore</b>. Hence, when one ends up spending on these things, it might seem like an extra expense as they have not planned for this. Some of these charges have to be paid even before the construction begins, and thus it becomes very important to plan your finances keeping these in mind so that you have the money at hand to submit your plans for sanction and to take care of other prerequisites that are important to get the construction started. </p>
        <p>Thus, it is highly recommended that you consider the cost involved in getting sanctions, approvals, and permissions from different authorities when you are planning your house construction budget.</p>
        <p>(2) &nbsp;Direct Cost: whether you choose to go for low-cost house construction in Bangalore or want something truly luxurious, the direct cost will be the services and items that demand the bigger portion of your finances. Some of the expenses that come under the direct cost are listed below:</p>
        <ul style={{marginLeft:"20px"}}>
            <li>Design - It includes the fees that you will have to pay the architect for designing your dream abode. This is comprehensive of your house plans, 3d renders, elevation design, and their construction ready drawings with accurate measurements to be sent to the site. </li>
            <li>Engineering &#8211;All the work related to engineering in building your house, relevant from soil testing to structural elements for stability, electrical, etc. is covered here. This includes the fee of the concerned consultant such as the structural engineer or electrical engineer as well. &nbsp;</li>
            <li>Construction &#8211;With respect to the materials and finishes discussed and finalised, the actual construction cost is quoted per square foot. </li>
            <li>Cost of getting a borewell in place is also a part of the direct expenses. </li>
            <li>Labour - labour charges as confirmed with your contractor. </li>
            <li>Interiors &#8211;Interior design has a wide spectrum of choices these days depending on your preferences. It can include getting your house designed according to a theme or a concept as well as varied materials and finishes. </li>
            <li>Transportation - cost incurred for transportation of material, water tankers, etc. </li>
        </ul>   
        <p>The <b>construction cost per square feet in Bangalore</b> will include most or all of these parameters depending on what kind of contract you have chosen. Therefore, if your estimate shows that your house construction cost is about &#8377;75 lakhs (G+3 Floors), you must remember that the compliance cost can be around &#8377;13 lakhs &nbsp;(Approx 15% to 28%) which makes the total cost &#8377;88 lakhs or so. This understanding helps you to prepare yourself in a sound manner to segregate your finances accordingly. </p>
        <p>The following table is a summary of different costs categorised as compliance cost and direct cost for better understanding. </p>
        <p><br /></p>
        <div>
            <table style={{width:"100%", marginLeft:"0px"}}>
            <tr >
                <th><p>Compliances Cost </p>
                </th>
                <th><p>Direct Cost </p>
                </th>
            </tr>
            <tr>
                <td><p>BBMP- Plan approval Cost</p>
                </td>
                <td><p>Design Cost: Floor, Plan, Geo-technical cost: Soil Testing, Structural Plan &amp; Front Elevation Design, Interior Design</p>
                </td>
            </tr>
            <tr >
                <td><p>BESCOM- Temp Connection </p>
                </td>
                <td><p>Construction Cost</p>
                </td>
            </tr>
            <tr>
                <td><p>Water for Construction / Borewell</p>
                </td>
                <td><p>Front Elevation Cost</p>
                </td>
            </tr>
            <tr>
                <td><p>BESCOM &lt; 500sq mtr: permanent meter, panel board grounding &amp; UG Cabling cost</p>
                </td>
                <td><p>Foundation Cost (Depth &gt; 5Ft)</p>
                </td>
            </tr>
            <tr>
                <td><p>BESCOM &gt; 500sqr mtr: Transformer cost in addition to above cost</p>
                </td>
                <td><p>Interior Works Cost</p>
                </td>
            </tr>
            <tr>
                <td><p>BWSSB: Pro-rata Charges with Official, Unofficial charges with road cutting &nbsp;</p>
                </td>
                <td><p>Elevator</p>
                </td>
            </tr>
        </table>
        </div>
        <p><br /></p>
        <p>As mentioned earlier, the house construction budget is not a standard amount and depends on many factors. Predominantly depending on the quality of material used, finishes and the workmanship involved, the <b>construction cost per square feet in Bangalore</b> &nbsp;depends on what the design of your house demands and what you wish to use to build your dream home. </p>
        <p>Different permutations and combinations are prevalent where you can choose to build using average material and use superior quality finishes, or you may choose to build using superior quality material while choosing average finishes or you may want to use the most superior products for both construction and finishes; thus, the cost per square foot is determined accordingly. </p>
        <p>Here are different tables explaining the cost of construction for different plot sizes that are widely seen in Bangalore for different kinds of budgets.</p>
        <p><br /></p>
        <div style={{overflow:"auto"}}>
            <table style={{width:"100%", marginLeft:"0px"}}>
            <tr>
                <th><p>Plot Area(feet)</p>
                </th>
                <th><p>Number of Floors</p>
                </th>
                <th><p>BUA (Built-up Area)</p>
                </th>
                <th><p>Cost Construction (Considering 1600 Rs/Sqft)</p>
                </th>
                <th><p>Borewell (800ft of Depth)</p>
                </th>
                <th><p>Other Works Cost</p>
                </th>
                <th><p>Compliance&#8217;s cost</p>
                </th>
                <th><p>Total Budget in Lakhs (approx)</p>
                </th>
            </tr>
            <tr >
                <td><p>20 x 30 Feet (600 Sqft)</p>
                </td>
                <td><p>Ground floor (G)</p>
                </td>
                <td><p>470 Sqft</p>
                </td>
                <td><p>7.52 Lakhs</p>
                </td>
                <td><p>2.1 Lakhs</p>
                </td>
                <td><p>3.3 Lakhs</p>
                </td>
                <td><p>2.15 Lakhs</p>
                </td>
                <td><p>15.1</p>
                </td>
            </tr>
            <tr >
                <td><p>20 x 30 Feet (600 Sqft)</p>
                </td>
                <td><p>Ground floor + 1 Floor (G+1)</p>
                </td>
                <td><p>940 Sqft</p>
                </td>
                <td><p>15.04 Lakhs</p>
                </td>
                <td><p>2.1 Lakhs</p>
                </td>
                <td><p>3.3 Lakhs</p>
                </td>
                <td><p>3.1 Lakhs</p>
                </td>
                <td><p>23.5</p>
                </td>
            </tr>
            <tr >
                <td><p>20 x 30 Feet (600 Sqft)</p>
                </td>
                <td><p>Ground floor + 2 Floors (G+2)</p>
                </td>
                <td><p>1410 Sqft</p>
                </td>
                <td><p>22.56 Lakhs</p>
                </td>
                <td><p>2.1 Lakhs</p>
                </td>
                <td><p>3.3 Lakhs</p>
                </td>
                <td><p>4 Lakhs</p>
                </td>
                <td><p>32.0</p>
                </td>
            </tr>
            <tr >
                <td><p>20 x 30 Feet (600 Sqft)</p>
                </td>
                <td><p>Ground floor + 3 Floors (G+3)</p>
                </td>
                <td><p>1880 Sqft</p>
                </td>
                <td><p>30.1 Lakhs</p>
                </td>
                <td><p>2.1 Lakhs</p>
                </td>
                <td><p>3.3 Lakhs</p>
                </td>
                <td><p>5 Lakhs</p>
                </td>
                <td><p>40.5</p>
                </td>
            </tr>
            <tr >
                <td><p>30 x 40 Feet (1200Sqft)</p>
                </td>
                <td><p>Ground floor (G)</p>
                </td>
                <td><p>940 Sqft</p>
                </td>
                <td><p>15.1 Lakhs</p>
                </td>
                <td><p>2.1 Lakhs</p>
                </td>
                <td><p>3.75 Lakhs</p>
                </td>
                <td><p>3 Lakhs</p>
                </td>
                <td><p>24.0</p>
                </td>
            </tr>
            <tr >
                <td><p>30 x 40 Feet (1200Sqft)</p>
                </td>
                <td><p>Ground floor + 1 Floor (G+1)</p>
                </td>
                <td><p>1880Sqft</p>
                </td>
                <td><p>30. 1Lakhs</p>
                </td>
                <td><p>2.1 Lakhs</p>
                </td>
                <td><p>3.75 Lakhs</p>
                </td>
                <td><p>4.5 Lakhs</p>
                </td>
                <td><p>40.5</p>
                </td>
            </tr>
            <tr >
                <td><p>30 x 40 Feet (1200Sqft)</p>
                </td>
                <td><p>Ground floor + 2 Floors (G+2)</p>
                </td>
                <td><p>2820 Sqft</p>
                </td>
                <td><p>45.1 Lakhs</p>
                </td>
                <td><p>2.1 Lakhs</p>
                </td>
                <td><p>3.75 Lakhs</p>
                </td>
                <td><p>6 Lakhs</p>
                </td>
                <td><p>57.0</p>
                </td>
            </tr>
            <tr >
                <td><p>30 x 40 Feet (1200Sqft)</p>
                </td>
                <td><p>Ground floor + 3 Floors (G+3)</p>
                </td>
                <td><p>3760 Sqft</p>
                </td>
                <td><p>60.2 Lakhs</p>
                </td>
                <td><p>2.1 Lakhs</p>
                </td>
                <td><p>3.75 Lakhs</p>
                </td>
                <td><p>7.6 Lakhs</p>
                </td>
                <td><p>73.7</p>
                </td>
            </tr>
            <tr >
                <td><p>30 x 50 Feet (1500Sqft)</p>
                </td>
                <td><p>Ground floor (G)</p>
                </td>
                <td><p>1175 Sqft</p>
                </td>
                <td><p>18.8 Lakhs</p>
                </td>
                <td><p>2.1 Lakhs</p>
                </td>
                <td><p>4.4 Lakhs</p>
                </td>
                <td><p>3.25 Lakhs</p>
                </td>
                <td><p>28.6</p>
                </td>
            </tr>
            <tr >
                <td><p>30 x 50 Feet (1500Sqft)</p>
                </td>
                <td><p>Ground floor + 1 Floor (G+1)</p>
                </td>
                <td><p>2350 Sqft</p>
                </td>
                <td><p>37.6 Lakhs</p>
                </td>
                <td><p>2.1 Lakhs</p>
                </td>
                <td><p>4.4 Lakhs</p>
                </td>
                <td><p>5.2 Lakhs</p>
                </td>
                <td><p>49.3</p>
                </td>
            </tr>
            <tr >
                <td><p>30 x 50 Feet (1500Sqft)</p>
                </td>
                <td><p>Ground floor + 2 Floors (G+2)</p>
                </td>
                <td><p>3525 Sqft</p>
                </td>
                <td><p>56.4 Lakhs</p>
                </td>
                <td><p>2.1 Lakhs</p>
                </td>
                <td><p>4.4 Lakhs</p>
                </td>
                <td><p>7.1 Lakhs</p>
                </td>
                <td><p>70.0</p>
                </td>
            </tr>
            <tr >
                <td><p>30 x 50 Feet (1500Sqft)</p>
                </td>
                <td><p>Ground floor + 3 Floors (G+3)</p>
                </td>
                <td><p>4700 Sqft</p>
                </td>
                <td><p>75.2 Lakhs</p>
                </td>
                <td><p>2.1 Lakhs</p>
                </td>
                <td><p>4.4 Lakhs</p>
                </td>
                <td><p>8 Lakhs</p>
                </td>
                <td><p>89.7</p>
                </td>
            </tr>
            <tr >
                <td><p>40 x 50 Feet (2000 Sqft)</p>
                </td>
                <td><p>Ground floor (G)</p>
                </td>
                <td><p>1600 Sqft</p>
                </td>
                <td><p>25.5 Lakhs</p>
                </td>
                <td><p>2.1 Lakhs</p>
                </td>
                <td><p>4.85 Lakhs</p>
                </td>
                <td><p>3.85 Lakhs</p>
                </td>
                <td><p>36.3</p>
                </td>
            </tr>
            <tr >
                <td><p>40 x 50 Feet (2000 Sqft)</p>
                </td>
                <td><p>Ground floor + 1 Floor (G+1)</p>
                </td>
                <td><p>3200 Sqft</p>
                </td>
                <td><p>51.2 Lakhs</p>
                </td>
                <td><p>2.1 Lakhs</p>
                </td>
                <td><p>4.85 Lakhs</p>
                </td>
                <td><p>6.35 Lakhs</p>
                </td>
                <td><p>64.5</p>
                </td>
            </tr>
            <tr >
                <td><p>40 x 50 Feet (2000 Sqft)</p>
                </td>
                <td><p>Ground floor + 2 Floors (G+2)</p>
                </td>
                <td><p>4800 Sqft</p>
                </td>
                <td><p>76.8 Lakhs</p>
                </td>
                <td><p>2.1 Lakhs</p>
                </td>
                <td><p>4.85 Lakhs</p>
                </td>
                <td><p>8.85 Lakhs</p>
                </td>
                <td><p>92.6</p>
                </td>
            </tr>
            <tr >
                <td><p>40 x 50 Feet (2000 Sqft)</p>
                </td>
                <td><p>Ground floor + 3 Floors (G+3)</p>
                </td>
                <td><p>6400 Sqft</p>
                </td>
                <td><p>1.02 Crores</p>
                </td>
                <td><p>2.1 Lakhs</p>
                </td>
                <td><p>4.85 Lakhs</p>
                </td>
                <td><p>11.4 Lakhs</p>
                </td>
                <td><p>120.4</p>
                </td>
            </tr>
            <tr >
                <td><p>40 x 60 Feet (2400 Sqft)</p>
                </td>
                <td><p>Ground floor (G)</p>
                </td>
                <td><p>1920 Sqft</p>
                </td>
                <td><p>30.72 Lakhs</p>
                </td>
                <td><p>2.1 Lakhs</p>
                </td>
                <td><p>5.4 Lakhs</p>
                </td>
                <td><p>4.3 Lakhs</p>
                </td>
                <td><p>42.5</p>
                </td>
            </tr>
            <tr >
                <td><p>40 x 60 Feet (2400 Sqft)</p>
                </td>
                <td><p>Ground floor + 1 Floor (G+1)</p>
                </td>
                <td><p>3840 Sqft</p>
                </td>
                <td><p>61.44 Lakhs</p>
                </td>
                <td><p>2.1 Lakhs</p>
                </td>
                <td><p>5.4 Lakhs</p>
                </td>
                <td><p>7.3 Lakhs</p>
                </td>
                <td><p>76.2</p>
                </td>
            </tr>
            <tr >
                <td><p>40 x 60 Feet (2400 Sqft)</p>
                </td>
                <td><p>Ground floor + 2 Floors (G+2)</p>
                </td>
                <td><p>5760 Sqft</p>
                </td>
                <td><p>92.16 Lakhs</p>
                </td>
                <td><p>2.1 Lakhs</p>
                </td>
                <td><p>5.4 Lakhs</p>
                </td>
                <td><p>10.25 Lakhs</p>
                </td>
                <td><p>109.9</p>
                </td>
            </tr>
            <tr >
                <td><p>40 x 60 Feet (2400 Sqft)</p>
                </td>
                <td><p>Ground floor + 3 Floors (G+3)</p>
                </td>
                <td><p>7680 Sqft</p>
                </td>
                <td><p>1.23 Crores</p>
                </td>
                <td><p>2.1 Lakhs</p>
                </td>
                <td><p>5.4 Lakhs</p>
                </td>
                <td><p>13.8 Lakhs</p>
                </td>
                <td><p>144.3</p>
                </td>
            </tr>
            <tr >
                <td colspan="8">
                    <div style={{ marginLeft:"20px" , textAlign:"left"}}>
                        <p>Note:</p>
                        <p>1) Compliances Cost Includes: BBMP Plan approval, BWSSB Water Connection, BESCOM Temporary Connection &amp; BESCOM Connection</p>
                        <p>2) Interiors Cost, Elevator, &amp; Front Elevation Cost will be additional</p>
                        <p>3) Other Works: Sump, Compound, Gates, Rain Water Harvesting, Front Drainage Slab</p>
                        <p>4) BUA/Floor Considered: - 20x30ft: 1BHK/Floor, 30x40ft: 2BHK/Floor, 30x50ft &amp; 40x50ft: 3BHK/Floor, 40x60ft: 4BHK/Floor</p>
                    </div>
                </td>
                </tr>
        </table>
        </div>
            <p><br /></p>

            <p><br /></p>
        <div style={{overflow:"auto"}}>

            <table style={{width:"100%", marginLeft:"0px"}}>
                <tr >
                    <th><p>Plot Area(feet)</p>
                    </th>
                    <th><p>Number of Floors</p>
                    </th>
                    <th><p>BUA (Built-up Area)</p>
                    </th>
                    <th><p>Cost Construction (Considering 1700 Rs/Sqft)</p>
                    </th>
                    <th><p>Borewell (800ft of Depth)</p>
                    </th>
                    <th><p>Other Works Cost</p>
                    </th>
                    <th><p>Compliance&#8217;s cost</p>
                    </th>
                    <th><p>Total Budget in Lakhs (approx)</p>
                    </th>
                </tr>
                <tr >
                    <td><p>20 x 30 Feet (600 Sqft)</p>
                    </td>
                    <td><p>Ground floor (G)</p>
                    </td>
                    <td><p>470 Sqft</p>
                    </td>
                    <td><p>8 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>3.3 Lakhs</p>
                    </td>
                    <td><p>2.15 Lakhs</p>
                    </td>
                    <td><p>15.55</p>
                    </td>
                </tr>
                <tr >
                    <td><p>20 x 30 Feet (600 Sqft)</p>
                    </td>
                    <td><p>Ground floor + 1 Floor (G+1)</p>
                    </td>
                    <td><p>940 Sqft</p>
                    </td>
                    <td><p>16 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>3.3 Lakhs</p>
                    </td>
                    <td><p>3.1 Lakhs</p>
                    </td>
                    <td><p>24.5</p>
                    </td>
                </tr>
                <tr >
                    <td><p>20 x 30 Feet (600 Sqft)</p>
                    </td>
                    <td><p>Ground floor + 2 Floors (G+2)</p>
                    </td>
                    <td><p>1410 Sqft</p>
                    </td>
                    <td><p>24 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>3.3 Lakhs</p>
                    </td>
                    <td><p>4 Lakhs</p>
                    </td>
                    <td><p>33.4</p>
                    </td>
                </tr>
                <tr >
                    <td><p>20 x 30 Feet (600 Sqft)</p>
                    </td>
                    <td><p>Ground floor + 3 Floors (G+3)</p>
                    </td>
                    <td><p>1880 Sqft</p>
                    </td>
                    <td><p>32 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>3.3 Lakhs</p>
                    </td>
                    <td><p>5 Lakhs</p>
                    </td>
                    <td><p>42.4</p>
                    </td>
                </tr>
                <tr >
                    <td><p>30 x 40 Feet (1200Sqft)</p>
                    </td>
                    <td><p>Ground floor (G)</p>
                    </td>
                    <td><p>940 Sqft</p>
                    </td>
                    <td><p>16 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>3.75 Lakhs</p>
                    </td>
                    <td><p>3 Lakhs</p>
                    </td>
                    <td><p>24.85</p>
                    </td>
                </tr>
                <tr >
                    <td><p>30 x 40 Feet (1200Sqft)</p>
                    </td>
                    <td><p>Ground floor + 1 Floor (G+1)</p>
                    </td>
                    <td><p>1880Sqft</p>
                    </td>
                    <td><p>32 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>3.75 Lakhs</p>
                    </td>
                    <td><p>4.5 Lakhs</p>
                    </td>
                    <td><p>42.35</p>
                    </td>
                </tr>
                <tr >
                    <td><p>30 x 40 Feet (1200Sqft)</p>
                    </td>
                    <td><p>Ground floor + 2 Floors (G+2)</p>
                    </td>
                    <td><p>2820 Sqft</p>
                    </td>
                    <td><p>47.9 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>3.75 Lakhs</p>
                    </td>
                    <td><p>6 Lakhs</p>
                    </td>
                    <td><p>59.75</p>
                    </td>
                </tr>
                <tr >
                    <td><p>30 x 40 Feet (1200Sqft)</p>
                    </td>
                    <td><p>Ground floor + 3 Floors (G+3)</p>
                    </td>
                    <td><p>3760 Sqft</p>
                    </td>
                    <td><p>63.9 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>3.75 Lakhs</p>
                    </td>
                    <td><p>7.6 Lakhs</p>
                    </td>
                    <td><p>77.35</p>
                    </td>
                </tr>
                <tr >
                    <td><p>30 x 50 Feet (1500Sqft)</p>
                    </td>
                    <td><p>Ground floor (G)</p>
                    </td>
                    <td><p>1175 Sqft</p>
                    </td>
                    <td><p>20 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>4.4 Lakhs</p>
                    </td>
                    <td><p>3.25 Lakhs</p>
                    </td>
                    <td><p>29.75</p>
                    </td>
                </tr>
                <tr >
                    <td><p>30 x 50 Feet (1500Sqft)</p>
                    </td>
                    <td><p>Ground floor + 1 Floor (G+1)</p>
                    </td>
                    <td><p>2350 Sqft</p>
                    </td>
                    <td><p>39.9 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>4.4 Lakhs</p>
                    </td>
                    <td><p>5.2 Lakhs</p>
                    </td>
                    <td><p>51.6</p>
                    </td>
                </tr>
                <tr >
                    <td><p>30 x 50 Feet (1500Sqft)</p>
                    </td>
                    <td><p>Ground floor + 2 Floors (G+2)</p>
                    </td>
                    <td><p>3525 Sqft</p>
                    </td>
                    <td><p>59.9 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>4.4 Lakhs</p>
                    </td>
                    <td><p>7.1 Lakhs</p>
                    </td>
                    <td><p>73.5</p>
                    </td>
                </tr>
                <tr >
                    <td><p>30 x 50 Feet (1500Sqft)</p>
                    </td>
                    <td><p>Ground floor + 3 Floors (G+3)</p>
                    </td>
                    <td><p>4700 Sqft</p>
                    </td>
                    <td><p>79.9 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>4.4 Lakhs</p>
                    </td>
                    <td><p>8 Lakhs</p>
                    </td>
                    <td><p>94.4</p>
                    </td>
                </tr>
                <tr >
                    <td><p>40 x 50 Feet (2000 Sqft)</p>
                    </td>
                    <td><p>Ground floor (G)</p>
                    </td>
                    <td><p>1600 Sqft</p>
                    </td>
                    <td><p>27.2 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>4.85 Lakhs</p>
                    </td>
                    <td><p>3.85 Lakhs</p>
                    </td>
                    <td><p>38</p>
                    </td>
                </tr>
                <tr >
                    <td><p>40 x 50 Feet (2000 Sqft)</p>
                    </td>
                    <td><p>Ground floor + 1 Floor (G+1)</p>
                    </td>
                    <td><p>3200 Sqft</p>
                    </td>
                    <td><p>54.4 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>4.85 Lakhs</p>
                    </td>
                    <td><p>6.35 Lakhs</p>
                    </td>
                    <td><p>67.7</p>
                    </td>
                </tr>
                <tr >
                    <td><p>40 x 50 Feet (2000 Sqft)</p>
                    </td>
                    <td><p>Ground floor + 2 Floors (G+2)</p>
                    </td>
                    <td><p>4800 Sqft</p>
                    </td>
                    <td><p>81.6 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>4.85 Lakhs</p>
                    </td>
                    <td><p>8.85 Lakhs</p>
                    </td>
                    <td><p>97.4</p>
                    </td>
                </tr>
                <tr >
                    <td><p>40 x 50 Feet (2000 Sqft)</p>
                    </td>
                    <td><p>Ground floor + 3 Floors (G+3)</p>
                    </td>
                    <td><p>6400 Sqft</p>
                    </td>
                    <td><p>1.09 Crores</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>4.85 Lakhs</p>
                    </td>
                    <td><p>11.4 Lakhs</p>
                    </td>
                    <td><p>127.35</p>
                    </td>
                </tr>
                <tr >
                    <td><p>40 x 60 Feet (2400 Sqft)</p>
                    </td>
                    <td><p>Ground floor (G)</p>
                    </td>
                    <td><p>1920 Sqft</p>
                    </td>
                    <td><p>32.6 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>5.4 Lakhs</p>
                    </td>
                    <td><p>4.3 Lakhs</p>
                    </td>
                    <td><p>44.4</p>
                    </td>
                </tr>
                <tr >
                    <td><p>40 x 60 Feet (2400 Sqft)</p>
                    </td>
                    <td><p>Ground floor + 1 Floor (G+1)</p>
                    </td>
                    <td><p>3840 Sqft</p>
                    </td>
                    <td><p>65.3 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>5.4 Lakhs</p>
                    </td>
                    <td><p>7.3 Lakhs</p>
                    </td>
                    <td><p>80.1</p>
                    </td>
                </tr>
                <tr >
                    <td><p>40 x 60 Feet (2400 Sqft)</p>
                    </td>
                    <td><p>Ground floor + 2 Floors (G+2)</p>
                    </td>
                    <td><p>5760 Sqft</p>
                    </td>
                    <td><p>99.9 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>5.4 Lakhs</p>
                    </td>
                    <td><p>10.25 Lakhs</p>
                    </td>
                    <td><p>117.65</p>
                    </td>
                </tr>
                <tr >
                    <td><p>40 x 60 Feet (2400 Sqft)</p>
                    </td>
                    <td><p>Ground floor + 3 Floors (G+3)</p>
                    </td>
                    <td><p>7680 Sqft</p>
                    </td>
                    <td><p>1.3 Crores</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>5.4 Lakhs</p>
                    </td>
                    <td><p>13.8 Lakhs</p>
                    </td>
                    <td><p>151.3</p>
                    </td>
                </tr>
                <tr >
                <td colspan="8">
                    <div style={{ marginLeft:"20px" , textAlign:"left"}}>
                        <p>Note:</p>
                        <p>1) Compliances Cost Includes: BBMP Plan approval, BWSSB Water Connection, BESCOM Temporary Connection &amp; BESCOM Connection</p>
                        <p>2) Interiors Cost, Elevator, &amp; Front Elevation Cost will be additional</p>
                        <p>3) Other Works: Sump, Compound, Gates, Rain Water Harvesting, Front Drainage Slab</p>
                        <p>4) BUA/Floor Considered: - 20x30ft: 1BHK/Floor, 30x40ft: 2BHK/Floor, 30x50ft &amp; 40x50ft: 3BHK/Floor, 40x60ft: 4BHK/Floor</p>
                    </div>
                </td>
                </tr>
            </table>
        </div>
        <p><br /></p>
        <h2><strong>Premium </strong></h2>
        <div style={{overflow:"auto"}}>
            <table style={{width:"100%", marginLeft:"0px"}}>
                <tr >
                    <th><p>Plot Area(feet)</p>
                    </th>
                    <th><p>Number of Floors</p>
                    </th>
                    <th><p>BUA (Built-up Area)</p>
                    </th>
                    <th><p>Cost Construction (Considering 1950 Rs/Sqft)</p>
                    </th>
                    <th><p>Borewell (800ft Depth)</p>
                    </th>
                    <th><p>Other Works Cost</p>
                    </th>
                    <th><p>Compliance&#8217;s cost</p>
                    </th>
                    <th><p>Total Budget in Lakhs (approx)</p>
                    </th>
                </tr>
                <tr >
                    <td><p>20 x 30 Feet (600 Sqft)</p>
                    </td>
                    <td><p>Ground floor (G)</p>
                    </td>
                    <td><p>470 Sqft</p>
                    </td>
                    <td><p>9.15 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>3.3 Lakhs</p>
                    </td>
                    <td><p>2.15 Lakhs</p>
                    </td>
                    <td><p>16.7</p>
                    </td>
                </tr>
                <tr >
                    <td><p>20 x 30 Feet (600 Sqft)</p>
                    </td>
                    <td><p>Ground floor + 1 Floor (G+1)</p>
                    </td>
                    <td><p>940 Sqft</p>
                    </td>
                    <td><p>18.35 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>3.3 Lakhs</p>
                    </td>
                    <td><p>3.1 Lakhs</p>
                    </td>
                    <td><p>26.9</p>
                    </td>
                </tr>
                <tr >
                    <td><p>20 x 30 Feet (600 Sqft)</p>
                    </td>
                    <td><p>Ground floor + 2 Floors (G+2)</p>
                    </td>
                    <td><p>1410 Sqft</p>
                    </td>
                    <td><p>27.5 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>3.3 Lakhs</p>
                    </td>
                    <td><p>4 Lakhs</p>
                    </td>
                    <td><p>36.9</p>
                    </td>
                </tr>
                <tr >
                    <td><p>20 x 30 Feet (600 Sqft)</p>
                    </td>
                    <td><p>Ground floor + 3 Floors (G+3)</p>
                    </td>
                    <td><p>1880 Sqft</p>
                    </td>
                    <td><p>36.7 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>3.3 Lakhs</p>
                    </td>
                    <td><p>5 Lakhs</p>
                    </td>
                    <td><p>47.1</p>
                    </td>
                </tr>
                <tr >
                    <td><p>30 x 40 Feet (1200Sqft)</p>
                    </td>
                    <td><p>Ground floor (G)</p>
                    </td>
                    <td><p>940 Sqft</p>
                    </td>
                    <td><p>18.35 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>3.75 Lakhs</p>
                    </td>
                    <td><p>3 Lakhs</p>
                    </td>
                    <td><p>27.2</p>
                    </td>
                </tr>
                <tr >
                    <td><p>30 x 40 Feet (1200Sqft)</p>
                    </td>
                    <td><p>Ground floor + 1 Floor (G+1)</p>
                    </td>
                    <td><p>1880Sqft</p>
                    </td>
                    <td><p>36.7 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>3.75 Lakhs</p>
                    </td>
                    <td><p>4.5 Lakhs</p>
                    </td>
                    <td><p>47.1</p>
                    </td>
                </tr>
                <tr >
                    <td><p>30 x 40 Feet (1200Sqft)</p>
                    </td>
                    <td><p>Ground floor + 2 Floors (G+2)</p>
                    </td>
                    <td><p>2820 Sqft</p>
                    </td>
                    <td><p>55 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>3.75 Lakhs</p>
                    </td>
                    <td><p>6 Lakhs</p>
                    </td>
                    <td><p>66.9</p>
                    </td>
                </tr>
                <tr >
                    <td><p>30 x 40 Feet (1200Sqft)</p>
                    </td>
                    <td><p>Ground floor + 3 Floors (G+3)</p>
                    </td>
                    <td><p>3760 Sqft</p>
                    </td>
                    <td><p>73.3 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>3.75 Lakhs</p>
                    </td>
                    <td><p>7.6 Lakhs</p>
                    </td>
                    <td><p>86.8</p>
                    </td>
                </tr>
                <tr >
                    <td><p>30 x 50 Feet (1500Sqft)</p>
                    </td>
                    <td><p>Ground floor (G)</p>
                    </td>
                    <td><p>1175 Sqft</p>
                    </td>
                    <td><p>23 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>4.4 Lakhs</p>
                    </td>
                    <td><p>3.25 Lakhs</p>
                    </td>
                    <td><p>32.8</p>
                    </td>
                </tr>
                <tr >
                    <td><p>30 x 50 Feet (1500Sqft)</p>
                    </td>
                    <td><p>Ground floor + 1 Floor (G+1)</p>
                    </td>
                    <td><p>2350 Sqft</p>
                    </td>
                    <td><p>45.8 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>4.4 Lakhs</p>
                    </td>
                    <td><p>5.2 Lakhs</p>
                    </td>
                    <td><p>57.5</p>
                    </td>
                </tr>
                <tr >
                    <td><p>30 x 50 Feet (1500Sqft)</p>
                    </td>
                    <td><p>Ground floor + 2 Floors (G+2)</p>
                    </td>
                    <td><p>3525 Sqft</p>
                    </td>
                    <td><p>68.7 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>4.4 Lakhs</p>
                    </td>
                    <td><p>7.1 Lakhs</p>
                    </td>
                    <td><p>82.3</p>
                    </td>
                </tr>
                <tr >
                    <td><p>30 x 50 Feet (1500Sqft)</p>
                    </td>
                    <td><p>Ground floor + 3 Floors (G+3)</p>
                    </td>
                    <td><p>4700 Sqft</p>
                    </td>
                    <td><p>91.7 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>4.4 Lakhs</p>
                    </td>
                    <td><p>8 Lakhs</p>
                    </td>
                    <td><p>106.2</p>
                    </td>
                </tr>
                <tr >
                    <td><p>40 x 50 Feet (2000 Sqft)</p>
                    </td>
                    <td><p>Ground floor (G)</p>
                    </td>
                    <td><p>1600 Sqft</p>
                    </td>
                    <td><p>31.2 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>4.85 Lakhs</p>
                    </td>
                    <td><p>3.85 Lakhs</p>
                    </td>
                    <td><p>42.0</p>
                    </td>
                </tr>
                <tr >
                    <td><p>40 x 50 Feet (2000 Sqft)</p>
                    </td>
                    <td><p>Ground floor + 1 Floor (G+1)</p>
                    </td>
                    <td><p>3200 Sqft</p>
                    </td>
                    <td><p>62.4 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>4.85 Lakhs</p>
                    </td>
                    <td><p>6.35 Lakhs</p>
                    </td>
                    <td><p>75.7</p>
                    </td>
                </tr>
                <tr >
                    <td><p>40 x 50 Feet (2000 Sqft)</p>
                    </td>
                    <td><p>Ground floor + 2 Floors (G+2)</p>
                    </td>
                    <td><p>4800 Sqft</p>
                    </td>
                    <td><p>93.6 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>4.85 Lakhs</p>
                    </td>
                    <td><p>8.85 Lakhs</p>
                    </td>
                    <td><p>109.4</p>
                    </td>
                </tr>
                <tr >
                    <td><p>40 x 50 Feet (2000 Sqft)</p>
                    </td>
                    <td><p>Ground floor + 3 Floors (G+3)</p>
                    </td>
                    <td><p>6400 Sqft</p>
                    </td>
                    <td><p>1.25 Crores</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>4.85 Lakhs</p>
                    </td>
                    <td><p>11.4 Lakhs</p>
                    </td>
                    <td><p>143.4</p>
                    </td>
                </tr>
                <tr >
                    <td><p>40 x 60 Feet (2400 Sqft)</p>
                    </td>
                    <td><p>Ground floor (G)</p>
                    </td>
                    <td><p>1920 Sqft</p>
                    </td>
                    <td><p>37.5 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>5.4 Lakhs</p>
                    </td>
                    <td><p>4.3 Lakhs</p>
                    </td>
                    <td><p>49.3</p>
                    </td>
                </tr>
                <tr >
                    <td><p>40 x 60 Feet (2400 Sqft)</p>
                    </td>
                    <td><p>Ground floor + 1 Floor (G+1)</p>
                    </td>
                    <td><p>3840 Sqft</p>
                    </td>
                    <td><p>74.9 Lakhs</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>5.4 Lakhs</p>
                    </td>
                    <td><p>7.3 Lakhs</p>
                    </td>
                    <td><p>89.7</p>
                    </td>
                </tr>
                <tr >
                    <td><p>40 x 60 Feet (2400 Sqft)</p>
                    </td>
                    <td><p>Ground floor + 2 Floors (G+2)</p>
                    </td>
                    <td><p>5760 Sqft</p>
                    </td>
                    <td><p>1.23 Crores</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>5.4 Lakhs</p>
                    </td>
                    <td><p>10.25 Lakhs</p>
                    </td>
                    <td><p>140.8</p>
                    </td>
                </tr>
                <tr >
                    <td><p>40 x 60 Feet (2400 Sqft)</p>
                    </td>
                    <td><p>Ground floor + 3 Floors (G+3)</p>
                    </td>
                    <td><p>7680 Sqft</p>
                    </td>
                    <td><p>1.5 Crores</p>
                    </td>
                    <td><p>2.1 Lakhs</p>
                    </td>
                    <td><p>5.4 Lakhs</p>
                    </td>
                    <td><p>13.8 Lakhs</p>
                    </td>
                    <td><p>171.3</p>
                    </td>
                </tr>
                <tr >
                <td colspan="8">
                    <div style={{ marginLeft:"20px" , textAlign:"left"}}>
                        <p>Note:</p>
                        <p>1) Compliances Cost Includes: BBMP Plan approval, BWSSB Water Connection, BESCOM Temporary Connection &amp; BESCOM Connection</p>
                        <p>2) Interiors Cost, Elevator, &amp; Front Elevation Cost will be additional</p>
                        <p>3) Other Works: Sump, Compound, Gates, Rain Water Harvesting, Front Drainage Slab</p>
                        <p>4) BUA/Floor Considered: - 20x30ft: 1BHK/Floor, 30x40ft: 2BHK/Floor, 30x50ft &amp; 40x50ft: 3BHK/Floor, 40x60ft: 4BHK/Floor</p>
                    </div>
                </td>
                </tr>
            </table>
        </div>

    </>,
    subTitle: "",
    subImg: "",
    description: "",
    separator: "",
    mSeparator: "",
    link1: "",
    link2: "",
    link3: "",
    link4: "",
    link5: "",
    link6: "",
    link7: "",
    link8: "",
    link9: "",
    link10: "",
    link11: "",
    subDescription:"",
};

